import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*!
  * Tempus Dominus v6.9.4 (https://getdatepicker.com/)
  * Copyright 2013-2023 Jonathan Peterson
  * Licensed under MIT (https://github.com/Eonasdan/tempus-dominus/blob/master/LICENSE)
  */
var TdError = /*#__PURE__*/function (_Error) {
  _inherits(TdError, _Error);

  var _super = _createSuper(TdError);

  function TdError() {
    _classCallCheck(this, TdError);

    return _super.apply(this, arguments);
  }

  return TdError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ErrorMessages = /*#__PURE__*/function () {
  function ErrorMessages() {
    _classCallCheck(this, ErrorMessages);

    this.base = 'TD:'; //#endregion
    //#region used with notify.error

    /**
     * Used with an Error Event type if the user selects a date that
     * fails restriction validation.
     */

    this.failedToSetInvalidDate = 'Failed to set invalid date';
    /**
     * Used with an Error Event type when a user changes the value of the
     * input field directly, and does not provide a valid date.
     */

    this.failedToParseInput = 'Failed parse input field'; //#endregion
  } //#region out to console

  /**
   * Throws an error indicating that a key in the options object is invalid.
   * @param optionName
   */


  _createClass(ErrorMessages, [{
    key: "unexpectedOption",
    value: function unexpectedOption(optionName) {
      var error = new TdError("".concat(this.base, " Unexpected option: ").concat(optionName, " does not match a known option."));
      error.code = 1;
      throw error;
    }
    /**
     * Throws an error indicating that one more keys in the options object is invalid.
     * @param optionName
     */

  }, {
    key: "unexpectedOptions",
    value: function unexpectedOptions(optionName) {
      var error = new TdError("".concat(this.base, ": ").concat(optionName.join(', ')));
      error.code = 1;
      throw error;
    }
    /**
     * Throws an error when an option is provide an unsupported value.
     * For example a value of 'cheese' for toolbarPlacement which only supports
     * 'top', 'bottom', 'default'.
     * @param optionName
     * @param badValue
     * @param validOptions
     */

  }, {
    key: "unexpectedOptionValue",
    value: function unexpectedOptionValue(optionName, badValue, validOptions) {
      var error = new TdError("".concat(this.base, " Unexpected option value: ").concat(optionName, " does not accept a value of \"").concat(badValue, "\". Valid values are: ").concat(validOptions.join(', ')));
      error.code = 2;
      throw error;
    }
    /**
     * Throws an error when an option value is the wrong type.
     * For example a string value was provided to multipleDates which only
     * supports true or false.
     * @param optionName
     * @param badType
     * @param expectedType
     */

  }, {
    key: "typeMismatch",
    value: function typeMismatch(optionName, badType, expectedType) {
      var error = new TdError("".concat(this.base, " Mismatch types: ").concat(optionName, " has a type of ").concat(badType, " instead of the required ").concat(expectedType));
      error.code = 3;
      throw error;
    }
    /**
     * Throws an error when an option value is  outside of the expected range.
     * For example restrictions.daysOfWeekDisabled excepts a value between 0 and 6.
     * @param optionName
     * @param lower
     * @param upper
     */

  }, {
    key: "numbersOutOfRange",
    value: function numbersOutOfRange(optionName, lower, upper) {
      var error = new TdError("".concat(this.base, " ").concat(optionName, " expected an array of number between ").concat(lower, " and ").concat(upper, "."));
      error.code = 4;
      throw error;
    }
    /**
     * Throws an error when a value for a date options couldn't be parsed. Either
     * the option was an invalid string or an invalid Date object.
     * @param optionName
     * @param date
     * @param soft If true, logs a warning instead of an error.
     */
    //eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "failedToParseDate",
    value: function failedToParseDate(optionName, date) {
      var soft = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var error = new TdError("".concat(this.base, " Could not correctly parse \"").concat(date, "\" to a date for ").concat(optionName, "."));
      error.code = 5;
      if (!soft) throw error;
      console.warn(error);
    }
    /**
     * Throws when an element to attach to was not provided in the constructor.
     */

  }, {
    key: "mustProvideElement",
    value: function mustProvideElement() {
      var error = new TdError("".concat(this.base, " No element was provided."));
      error.code = 6;
      throw error;
    }
    /**
     * Throws if providing an array for the events to subscribe method doesn't have
     * the same number of callbacks. E.g., subscribe([1,2], [1])
     */

  }, {
    key: "subscribeMismatch",
    value: function subscribeMismatch() {
      var error = new TdError("".concat(this.base, " The subscribed events does not match the number of callbacks"));
      error.code = 7;
      throw error;
    }
    /**
     * Throws if the configuration has conflicting rules e.g. minDate is after maxDate
     */

  }, {
    key: "conflictingConfiguration",
    value: function conflictingConfiguration(message) {
      var error = new TdError("".concat(this.base, " A configuration value conflicts with another rule. ").concat(message));
      error.code = 8;
      throw error;
    }
    /**
     * customDateFormat errors
     */

  }, {
    key: "customDateFormatError",
    value: function customDateFormatError(message) {
      var error = new TdError("".concat(this.base, " Custom Date Format: ").concat(message));
      error.code = 9;
      throw error;
    }
    /**
     * Logs a warning if a date option value is provided as a string, instead of
     * a date/datetime object.
     */

  }, {
    key: "dateString",
    value: function dateString() {
      console.warn("".concat(this.base, " Using a string for date options is not recommended unless you specify an ISO string or use the customDateFormat plugin."));
    }
  }, {
    key: "deprecatedWarning",
    value: function deprecatedWarning(message, remediation) {
      console.warn("".concat(this.base, " Warning ").concat(message, " is deprecated and will be removed in a future version. ").concat(remediation));
    }
  }, {
    key: "throwError",
    value: function throwError(message) {
      var error = new TdError("".concat(this.base, " ").concat(message));
      error.code = 9;
      throw error;
    }
  }]);

  return ErrorMessages;
}(); // this is not the way I want this to stay but nested classes seemed to blown up once its compiled.


var NAME = 'tempus-dominus',
    dataKey = 'td';
/**
 * Events
 */

var Events = function Events() {
  _classCallCheck(this, Events);

  this.key = ".".concat(dataKey);
  /**
   * Change event. Fired when the user selects a date.
   * See also EventTypes.ChangeEvent
   */

  this.change = "change".concat(this.key);
  /**
   * Emit when the view changes for example from month view to the year view.
   * See also EventTypes.ViewUpdateEvent
   */

  this.update = "update".concat(this.key);
  /**
   * Emits when a selected date or value from the input field fails to meet the provided validation rules.
   * See also EventTypes.FailEvent
   */

  this.error = "error".concat(this.key);
  /**
   * Show event
   * @event Events#show
   */

  this.show = "show".concat(this.key);
  /**
   * Hide event
   * @event Events#hide
   */

  this.hide = "hide".concat(this.key); // blur and focus are used in the jQuery provider but are otherwise unused.
  // keyup/down will be used later for keybinding options

  this.blur = "blur".concat(this.key);
  this.focus = "focus".concat(this.key);
  this.keyup = "keyup".concat(this.key);
  this.keydown = "keydown".concat(this.key);
};

var Css = function Css() {
  _classCallCheck(this, Css);

  /**
   * The outer element for the widget.
   */
  this.widget = "".concat(NAME, "-widget");
  /**
   * Hold the previous, next and switcher divs
   */

  this.calendarHeader = 'calendar-header';
  /**
   * The element for the action to change the calendar view. E.g. month -> year.
   */

  this.switch = 'picker-switch';
  /**
   * The elements for all the toolbar options
   */

  this.toolbar = 'toolbar';
  /**
   * Disables the hover and rounding affect.
   */

  this.noHighlight = 'no-highlight';
  /**
   * Applied to the widget element when the side by side option is in use.
   */

  this.sideBySide = 'timepicker-sbs';
  /**
   * The element for the action to change the calendar view, e.g. August -> July
   */

  this.previous = 'previous';
  /**
   * The element for the action to change the calendar view, e.g. August -> September
   */

  this.next = 'next';
  /**
   * Applied to any action that would violate any restriction options. ALso applied
   * to an input field if the disabled function is called.
   */

  this.disabled = 'disabled';
  /**
   * Applied to any date that is less than requested view,
   * e.g. the last day of the previous month.
   */

  this.old = 'old';
  /**
   * Applied to any date that is greater than of requested view,
   * e.g. the last day of the previous month.
   */

  this.new = 'new';
  /**
   * Applied to any date that is currently selected.
   */

  this.active = 'active'; //#region date element

  /**
   * The outer element for the calendar view.
   */

  this.dateContainer = 'date-container';
  /**
   * The outer element for the decades view.
   */

  this.decadesContainer = "".concat(this.dateContainer, "-decades");
  /**
   * Applied to elements within the decade container, e.g. 2020, 2030
   */

  this.decade = 'decade';
  /**
   * The outer element for the years view.
   */

  this.yearsContainer = "".concat(this.dateContainer, "-years");
  /**
   * Applied to elements within the years container, e.g. 2021, 2021
   */

  this.year = 'year';
  /**
   * The outer element for the month view.
   */

  this.monthsContainer = "".concat(this.dateContainer, "-months");
  /**
   * Applied to elements within the month container, e.g. January, February
   */

  this.month = 'month';
  /**
   * The outer element for the calendar view.
   */

  this.daysContainer = "".concat(this.dateContainer, "-days");
  /**
   * Applied to elements within the day container, e.g. 1, 2..31
   */

  this.day = 'day';
  /**
   * If display.calendarWeeks is enabled, a column displaying the week of year
   * is shown. This class is applied to each cell in that column.
   */

  this.calendarWeeks = 'cw';
  /**
   * Applied to the first row of the calendar view, e.g. Sunday, Monday
   */

  this.dayOfTheWeek = 'dow';
  /**
   * Applied to the current date on the calendar view.
   */

  this.today = 'today';
  /**
   * Applied to the locale's weekend dates on the calendar view, e.g. Sunday, Saturday
   */

  this.weekend = 'weekend';
  this.rangeIn = 'range-in';
  this.rangeStart = 'range-start';
  this.rangeEnd = 'range-end'; //#endregion
  //#region time element

  /**
   * The outer element for all time related elements.
   */

  this.timeContainer = 'time-container';
  /**
   * Applied the separator columns between time elements, e.g. hour *:* minute *:* second
   */

  this.separator = 'separator';
  /**
   * The outer element for the clock view.
   */

  this.clockContainer = "".concat(this.timeContainer, "-clock");
  /**
   * The outer element for the hours selection view.
   */

  this.hourContainer = "".concat(this.timeContainer, "-hour");
  /**
   * The outer element for the minutes selection view.
   */

  this.minuteContainer = "".concat(this.timeContainer, "-minute");
  /**
   * The outer element for the seconds selection view.
   */

  this.secondContainer = "".concat(this.timeContainer, "-second");
  /**
   * Applied to each element in the hours selection view.
   */

  this.hour = 'hour';
  /**
   * Applied to each element in the minutes selection view.
   */

  this.minute = 'minute';
  /**
   * Applied to each element in the seconds selection view.
   */

  this.second = 'second';
  /**
   * Applied AM/PM toggle button.
   */

  this.toggleMeridiem = 'toggleMeridiem'; //#endregion
  //#region collapse

  /**
   * Applied the element of the current view mode, e.g. calendar or clock.
   */

  this.show = 'show';
  /**
   * Applied to the currently showing view mode during a transition
   * between calendar and clock views
   */

  this.collapsing = 'td-collapsing';
  /**
   * Applied to the currently hidden view mode.
   */

  this.collapse = 'td-collapse'; //#endregion

  /**
   * Applied to the widget when the option display.inline is enabled.
   */

  this.inline = 'inline';
  /**
   * Applied to the widget when the option display.theme is light.
   */

  this.lightTheme = 'light';
  /**
   * Applied to the widget when the option display.theme is dark.
   */

  this.darkTheme = 'dark';
  /**
   * Used for detecting if the system color preference is dark mode
   */

  this.isDarkPreferredQuery = '(prefers-color-scheme: dark)';
};

var Namespace = function Namespace() {
  _classCallCheck(this, Namespace);
};

Namespace.NAME = NAME; // noinspection JSUnusedGlobalSymbols

Namespace.dataKey = dataKey;
Namespace.events = new Events();
Namespace.css = new Css();
Namespace.errorMessages = new ErrorMessages();
var DefaultFormatLocalization = {
  dateFormats: {
    LTS: 'h:mm:ss T',
    LT: 'h:mm T',
    L: 'MM/dd/yyyy',
    LL: 'MMMM d, yyyy',
    LLL: 'MMMM d, yyyy h:mm T',
    LLLL: 'dddd, MMMM d, yyyy h:mm T'
  },
  format: 'L LT',
  locale: 'default',
  hourCycle: undefined,
  ordinal: function ordinal(n) {
    var s = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return "[".concat(n).concat(s[(v - 20) % 10] || s[v] || s[0], "]");
  }
};

var DefaultFormatLocalization$1 = _objectSpread({}, DefaultFormatLocalization);

var Unit;

(function (Unit) {
  Unit["seconds"] = "seconds";
  Unit["minutes"] = "minutes";
  Unit["hours"] = "hours";
  Unit["date"] = "date";
  Unit["month"] = "month";
  Unit["year"] = "year";
})(Unit || (Unit = {}));

var twoDigitTemplate = {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
};
/**
 * Returns an Intl format object based on the provided object
 * @param unit
 */

var getFormatByUnit = function getFormatByUnit(unit) {
  switch (unit) {
    case 'date':
      return {
        dateStyle: 'short'
      };

    case 'month':
      return {
        month: 'numeric',
        year: 'numeric'
      };

    case 'year':
      return {
        year: 'numeric'
      };
  }
};
/**
 * Attempts to guess the hour cycle of the given local
 * @param locale
 */


var guessHourCycle = function guessHourCycle(locale) {
  if (!locale) return 'h12'; // noinspection SpellCheckingInspection

  var template = {
    hour: '2-digit',
    minute: '2-digit',
    numberingSystem: 'latn'
  };
  var dt = new DateTime().setLocalization({
    locale: locale
  });
  dt.hours = 0;
  var start = dt.parts(undefined, template).hour; //midnight is 12 so en-US style 12 AM

  if (start === '12') return 'h12'; //midnight is 24 is from 00-24

  if (start === '24') return 'h24';
  dt.hours = 23;
  var end = dt.parts(undefined, template).hour; //if midnight is 00 and hour 23 is 11 then

  if (start === '00' && end === '11') return 'h11';
  if (start === '00' && end === '23') return 'h23';
  console.warn("couldn't determine hour cycle for ".concat(locale, ". start: ").concat(start, ". end: ").concat(end));
  return undefined;
};
/**
 * For the most part this object behaves exactly the same way
 * as the native Date object with a little extra spice.
 */


var DateTime = /*#__PURE__*/function (_Date) {
  _inherits(DateTime, _Date);

  var _super2 = _createSuper(DateTime);

  function DateTime() {
    var _this;

    _classCallCheck(this, DateTime);

    _this = _super2.apply(this, arguments);
    _this.localization = DefaultFormatLocalization$1;
    _this.nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
    _this.leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335]; //#region CDF stuff

    _this.dateTimeRegex = //is regex cannot be simplified beyond what it already is
    /(\[[^[\]]*])|y{1,4}|M{1,4}|d{1,4}|H{1,2}|h{1,2}|t|T|m{1,2}|s{1,2}|f{3}/g; //NOSONAR

    _this.formattingTokens = /(\[[^[\]]*])|([-_:/.,()\s]+)|(T|t|yyyy|yy?|MM?M?M?|Do|dd?d?d?|hh?|HH?|mm?|ss?)/g; //NOSONAR is regex cannot be simplified beyond what it already is

    _this.match2 = /\d\d/; // 00 - 99

    _this.match3 = /\d{3}/; // 000 - 999

    _this.match4 = /\d{4}/; // 0000 - 9999

    _this.match1to2 = /\d\d?/; // 0 - 99

    _this.matchSigned = /[+-]?\d+/; // -inf - inf

    _this.matchOffset = /[+-]\d\d:?(\d\d)?|Z/; // +00:00 -00:00 +0000 or -0000 +00 or Z

    _this.matchWord = /[^\d_:/,\-()\s]+/; // Word

    _this.zoneExpressions = [_this.matchOffset, function (obj, input) {
      obj.offset = _this.offsetFromString(input);
    }];
    _this.expressions = {
      t: {
        pattern: undefined,
        parser: function parser(obj, input) {
          obj.afternoon = _this.meridiemMatch(input);
        }
      },
      T: {
        pattern: undefined,
        parser: function parser(obj, input) {
          obj.afternoon = _this.meridiemMatch(input);
        }
      },
      fff: {
        pattern: _this.match3,
        parser: function parser(obj, input) {
          obj.milliseconds = +input;
        }
      },
      s: {
        pattern: _this.match1to2,
        parser: _this.addInput('seconds')
      },
      ss: {
        pattern: _this.match1to2,
        parser: _this.addInput('seconds')
      },
      m: {
        pattern: _this.match1to2,
        parser: _this.addInput('minutes')
      },
      mm: {
        pattern: _this.match1to2,
        parser: _this.addInput('minutes')
      },
      H: {
        pattern: _this.match1to2,
        parser: _this.addInput('hours')
      },
      h: {
        pattern: _this.match1to2,
        parser: _this.addInput('hours')
      },
      HH: {
        pattern: _this.match1to2,
        parser: _this.addInput('hours')
      },
      hh: {
        pattern: _this.match1to2,
        parser: _this.addInput('hours')
      },
      d: {
        pattern: _this.match1to2,
        parser: _this.addInput('day')
      },
      dd: {
        pattern: _this.match2,
        parser: _this.addInput('day')
      },
      Do: {
        pattern: _this.matchWord,
        parser: function parser(obj, input) {
          obj.day = +(input.match(/\d+/)[0] || 1);
          if (!_this.localization.ordinal) return;

          for (var i = 1; i <= 31; i += 1) {
            if (_this.localization.ordinal(i).replace(/[[\]]/g, '') === input) {
              obj.day = i;
            }
          }
        }
      },
      M: {
        pattern: _this.match1to2,
        parser: _this.addInput('month')
      },
      MM: {
        pattern: _this.match2,
        parser: _this.addInput('month')
      },
      MMM: {
        pattern: _this.matchWord,
        parser: function parser(obj, input) {
          var months = _this.getAllMonths();

          var monthsShort = _this.getAllMonths('short');

          var matchIndex = (monthsShort || months.map(function (_) {
            return _.slice(0, 3);
          })).indexOf(input) + 1;

          if (matchIndex < 1) {
            throw new Error();
          }

          obj.month = matchIndex % 12 || matchIndex;
        }
      },
      MMMM: {
        pattern: _this.matchWord,
        parser: function parser(obj, input) {
          var months = _this.getAllMonths();

          var matchIndex = months.indexOf(input) + 1;

          if (matchIndex < 1) {
            throw new Error();
          }

          obj.month = matchIndex % 12 || matchIndex;
        }
      },
      y: {
        pattern: _this.matchSigned,
        parser: _this.addInput('year')
      },
      yy: {
        pattern: _this.match2,
        parser: function parser(obj, input) {
          obj.year = _this.parseTwoDigitYear(+input);
        }
      },
      yyyy: {
        pattern: _this.match4,
        parser: _this.addInput('year')
      } // z: this.zoneExpressions,
      // zz: this.zoneExpressions,
      // zzz: this.zoneExpressions

    }; //#endregion CDF stuff

    return _this;
  }
  /**
   * Chainable way to set the {@link locale}
   * @param value
   * @deprecated use setLocalization with a FormatLocalization object instead
   */


  _createClass(DateTime, [{
    key: "setLocale",
    value: function setLocale(value) {
      if (!this.localization) {
        this.localization = DefaultFormatLocalization$1;
        this.localization.locale = value;
      }

      return this;
    }
    /**
     * Chainable way to set the {@link localization}
     * @param value
     */

  }, {
    key: "setLocalization",
    value: function setLocalization(value) {
      this.localization = value;
      return this;
    }
    /**
     * Converts a plain JS date object to a DateTime object.
     * Doing this allows access to format, etc.
     * @param  date
     * @param locale this parameter is deprecated. Use formatLocalization instead.
     * @param formatLocalization
     */

  }, {
    key: "startOf",

    /**
     * Sets the current date to the start of the {@link unit} provided
     * Example: Consider a date of "April 30, 2021, 11:45:32.984 AM" => new DateTime(2021, 3, 30, 11, 45, 32, 984).startOf('month')
     * would return April 1, 2021, 12:00:00.000 AM (midnight)
     * @param unit
     * @param startOfTheWeek Allows for the changing the start of the week.
     */
    value: function startOf(unit) {
      var startOfTheWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (this[unit] === undefined) throw new Error("Unit '".concat(unit, "' is not valid"));

      switch (unit) {
        case 'seconds':
          this.setMilliseconds(0);
          break;

        case 'minutes':
          this.setSeconds(0, 0);
          break;

        case 'hours':
          this.setMinutes(0, 0, 0);
          break;

        case 'date':
          this.setHours(0, 0, 0, 0);
          break;

        case 'weekDay':
          {
            this.startOf(Unit.date);
            if (this.weekDay === startOfTheWeek) break;
            var goBack = (this.weekDay - startOfTheWeek + 7) % 7;
            this.manipulate(goBack * -1, Unit.date);
            break;
          }

        case 'month':
          this.startOf(Unit.date);
          this.setDate(1);
          break;

        case 'year':
          this.startOf(Unit.date);
          this.setMonth(0, 1);
          break;
      }

      return this;
    }
    /**
     * Sets the current date to the end of the {@link unit} provided
     * Example: Consider a date of "April 30, 2021, 11:45:32.984 AM" => new DateTime(2021, 3, 30, 11, 45, 32, 984).endOf('month')
     * would return April 30, 2021, 11:59:59.999 PM
     * @param unit
     * @param startOfTheWeek
     */

  }, {
    key: "endOf",
    value: function endOf(unit) {
      var startOfTheWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (this[unit] === undefined) throw new Error("Unit '".concat(unit, "' is not valid"));

      switch (unit) {
        case 'seconds':
          this.setMilliseconds(999);
          break;

        case 'minutes':
          this.setSeconds(59, 999);
          break;

        case 'hours':
          this.setMinutes(59, 59, 999);
          break;

        case 'date':
          this.setHours(23, 59, 59, 999);
          break;

        case 'weekDay':
          {
            this.endOf(Unit.date);
            var endOfWeek = 6 + startOfTheWeek;
            if (this.weekDay === endOfWeek) break;
            this.manipulate(endOfWeek - this.weekDay, Unit.date);
            break;
          }

        case 'month':
          this.endOf(Unit.date);
          this.manipulate(1, Unit.month);
          this.setDate(0);
          break;

        case 'year':
          this.endOf(Unit.date);
          this.setMonth(11, 31);
          break;
      }

      return this;
    }
    /**
     * Change a {@link unit} value. Value can be positive or negative
     * Example: Consider a date of "April 30, 2021, 11:45:32.984 AM" => new DateTime(2021, 3, 30, 11, 45, 32, 984).manipulate(1, 'month')
     * would return May 30, 2021, 11:45:32.984 AM
     * @param value A positive or negative number
     * @param unit
     */

  }, {
    key: "manipulate",
    value: function manipulate(value, unit) {
      if (this[unit] === undefined) throw new Error("Unit '".concat(unit, "' is not valid"));
      this[unit] += value;
      return this;
    }
    /**
     * Return true if {@link compare} is before this date
     * @param compare The Date/DateTime to compare
     * @param unit If provided, uses {@link startOf} for
     * comparison.
     */

  }, {
    key: "isBefore",
    value: function isBefore(compare, unit) {
      // If the comparisons is undefined, return false
      if (!DateTime.isValid(compare)) return false;
      if (!unit) return this.valueOf() < compare.valueOf();
      if (this[unit] === undefined) throw new Error("Unit '".concat(unit, "' is not valid"));
      return this.clone.startOf(unit).valueOf() < compare.clone.startOf(unit).valueOf();
    }
    /**
     * Return true if {@link compare} is after this date
     * @param compare The Date/DateTime to compare
     * @param unit If provided, uses {@link startOf} for
     * comparison.
     */

  }, {
    key: "isAfter",
    value: function isAfter(compare, unit) {
      // If the comparisons is undefined, return false
      if (!DateTime.isValid(compare)) return false;
      if (!unit) return this.valueOf() > compare.valueOf();
      if (this[unit] === undefined) throw new Error("Unit '".concat(unit, "' is not valid"));
      return this.clone.startOf(unit).valueOf() > compare.clone.startOf(unit).valueOf();
    }
    /**
     * Return true if {@link compare} is same this date
     * @param compare The Date/DateTime to compare
     * @param unit If provided, uses {@link startOf} for
     * comparison.
     */

  }, {
    key: "isSame",
    value: function isSame(compare, unit) {
      // If the comparisons is undefined, return false
      if (!DateTime.isValid(compare)) return false;
      if (!unit) return this.valueOf() === compare.valueOf();
      if (this[unit] === undefined) throw new Error("Unit '".concat(unit, "' is not valid"));
      compare = DateTime.convert(compare);
      return this.clone.startOf(unit).valueOf() === compare.startOf(unit).valueOf();
    }
    /**
     * Check if this is between two other DateTimes, optionally looking at unit scale. The match is exclusive.
     * @param left
     * @param right
     * @param unit.
     * @param inclusivity. A [ indicates inclusion of a value. A ( indicates exclusion.
     * If the inclusivity parameter is used, both indicators must be passed.
     */

  }, {
    key: "isBetween",
    value: function isBetween(left, right, unit) {
      var inclusivity = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '()';
      // If one of the comparisons is undefined, return false
      if (!DateTime.isValid(left) || !DateTime.isValid(right)) return false; // If a unit is provided and is not a valid property of the DateTime object, throw an error

      if (unit && this[unit] === undefined) {
        throw new Error("Unit '".concat(unit, "' is not valid"));
      }

      var leftInclusivity = inclusivity[0] === '(';
      var rightInclusivity = inclusivity[1] === ')';
      var isLeftInRange = leftInclusivity ? this.isAfter(left, unit) : !this.isBefore(left, unit);
      var isRightInRange = rightInclusivity ? this.isBefore(right, unit) : !this.isAfter(right, unit);
      return isLeftInRange && isRightInRange;
    }
    /**
     * Returns flattened object of the date. Does not include literals
     * @param locale
     * @param template
     */

  }, {
    key: "parts",
    value: function parts() {
      var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.localization.locale;
      var template = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        dateStyle: 'full',
        timeStyle: 'long'
      };
      var parts = {};
      new Intl.DateTimeFormat(locale, template).formatToParts(this).filter(function (x) {
        return x.type !== 'literal';
      }).forEach(function (x) {
        return parts[x.type] = x.value;
      });
      return parts;
    }
    /**
     * Shortcut to Date.getSeconds()
     */

  }, {
    key: "getHoursFormatted",

    /**
     * Returns two digit hour, e.g. 01...10
     * @param hourCycle Providing an hour cycle will change 00 to 24 depending on the given value.
     */
    value: function getHoursFormatted() {
      var hourCycle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'h12';
      return this.parts(undefined, _objectSpread(_objectSpread({}, twoDigitTemplate), {}, {
        hourCycle: hourCycle
      })).hour;
    }
    /**
     * Get the meridiem of the date. E.g. AM or PM.
     * If the {@link locale} provides a "dayPeriod" then this will be returned,
     * otherwise it will return AM or PM.
     * @param locale
     */

  }, {
    key: "meridiem",
    value: function meridiem() {
      var _Intl$DateTimeFormat$;

      var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.localization.locale;
      return (_Intl$DateTimeFormat$ = new Intl.DateTimeFormat(locale, {
        hour: 'numeric',
        hour12: true
      }).formatToParts(this).find(function (p) {
        return p.type === 'dayPeriod';
      })) === null || _Intl$DateTimeFormat$ === void 0 ? void 0 : _Intl$DateTimeFormat$.value;
    }
    /**
     * Shortcut to Date.getDate()
     */

  }, {
    key: "weeksInWeekYear",

    /**
     * Returns the number of weeks in the year
     */
    value: function weeksInWeekYear() {
      var p1 = (this.year + Math.floor(this.year / 4) - Math.floor(this.year / 100) + Math.floor(this.year / 400)) % 7,
          last = this.year - 1,
          p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
      return p1 === 4 || p2 === 3 ? 53 : 52;
    }
    /**
     * Returns true or false depending on if the year is a leap year or not.
     */

  }, {
    key: "computeOrdinal",
    value: function computeOrdinal() {
      return this.date + (this.isLeapYear ? this.leapLadder : this.nonLeapLadder)[this.month];
    }
    /**
     * Returns a list of month values based on the current locale
     */

  }, {
    key: "getAllMonths",
    value: function getAllMonths() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'long';
      var applyFormat = new Intl.DateTimeFormat(this.localization.locale, {
        month: format
      }).format;
      return _toConsumableArray(Array(12).keys()).map(function (m) {
        return applyFormat(new Date(2021, m));
      });
    }
    /**
     * Replaces an expanded token set (e.g. LT/LTS)
     */

  }, {
    key: "replaceTokens",
    value: function replaceTokens(formatStr, formats) {
      /***
       * _ => match
       * a => first capture group. Anything between [ and ]
       * b => second capture group
       */
      return formatStr.replace(/(\[[^[\]]*])|(LTS?|l{1,4}|L{1,4})/g, function (_, a, b) {
        var B = b && b.toUpperCase();
        return a || formats[B] || DefaultFormatLocalization$1.dateFormats[B];
      });
    }
  }, {
    key: "parseTwoDigitYear",
    value: function parseTwoDigitYear(input) {
      return input + (input > 68 ? 1900 : 2000);
    }
  }, {
    key: "offsetFromString",
    value: function offsetFromString(input) {
      if (!input) return 0;
      if (input === 'Z') return 0;

      var _input$match = input.match(/([+-]|\d\d)/g),
          _input$match2 = _slicedToArray(_input$match, 3),
          first = _input$match2[0],
          second = _input$match2[1],
          third = _input$match2[2];

      var minutes = +second * 60 + (+third || 0);
      var signed = first === '+' ? -minutes : minutes;
      return minutes === 0 ? 0 : signed; // eslint-disable-line no-nested-ternary
    }
    /**
     * z = -4, zz = -04, zzz = -0400
     * @param date
     * @param style
     * @private
     */

  }, {
    key: "zoneInformation",
    value: function zoneInformation(date, style) {
      var name = date.parts(this.localization.locale, {
        timeZoneName: 'longOffset'
      }).timeZoneName.replace('GMT', '').replace(':', '');
      var negative = name.includes('-');
      name = name.replace('-', '');
      if (style === 'z') name = name.substring(1, 2);else if (style === 'zz') name = name.substring(0, 2);
      return "".concat(negative ? '-' : '').concat(name);
    }
  }, {
    key: "addInput",
    value: function addInput(property) {
      return function (obj, input) {
        obj[property] = +input;
      };
    }
  }, {
    key: "getLocaleAfternoon",
    value: function getLocaleAfternoon() {
      var _Intl$DateTimeFormat$2, _Intl$DateTimeFormat$3;

      return (_Intl$DateTimeFormat$2 = new Intl.DateTimeFormat(this.localization.locale, {
        hour: 'numeric',
        hour12: true
      }).formatToParts(new Date(2022, 3, 4, 13)).find(function (p) {
        return p.type === 'dayPeriod';
      })) === null || _Intl$DateTimeFormat$2 === void 0 ? void 0 : (_Intl$DateTimeFormat$3 = _Intl$DateTimeFormat$2.value) === null || _Intl$DateTimeFormat$3 === void 0 ? void 0 : _Intl$DateTimeFormat$3.replace(/\s+/g, ' ');
    }
  }, {
    key: "meridiemMatch",
    value: function meridiemMatch(input) {
      return input.toLowerCase() === this.getLocaleAfternoon().toLowerCase();
    }
  }, {
    key: "correctHours",
    value: function correctHours(time) {
      var afternoon = time.afternoon;

      if (afternoon !== undefined) {
        var hours = time.hours;

        if (afternoon) {
          if (hours < 12) {
            time.hours += 12;
          }
        } else if (hours === 12) {
          time.hours = 0;
        }

        delete time.afternoon;
      }
    }
  }, {
    key: "makeParser",
    value: function makeParser(format) {
      var _this2 = this;

      format = this.replaceTokens(format, this.localization.dateFormats);
      var matchArray = format.match(this.formattingTokens);
      var length = matchArray.length;
      var expressionArray = [];

      for (var i = 0; i < length; i += 1) {
        var token = matchArray[i];
        var expression = this.expressions[token];

        if (expression === null || expression === void 0 ? void 0 : expression.parser) {
          expressionArray[i] = expression;
        } else {
          expressionArray[i] = token.replace(/^\[[^[\]]*]$/g, '');
        }
      }

      return function (input) {
        var time = {
          hours: 0,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        };

        for (var _i2 = 0, start = 0; _i2 < length; _i2 += 1) {
          var _token = expressionArray[_i2];

          if (typeof _token === 'string') {
            start += _token.length;
          } else {
            var part = input.slice(start);
            var value = part;

            if (_token.pattern) {
              var match = _token.pattern.exec(part);

              value = match[0];
            }

            _token.parser.call(_this2, time, value);

            input = input.replace(value, '');
          }
        }

        _this2.correctHours(time);

        return time;
      };
    }
    /**
     * Attempts to create a DateTime from a string.
     * @param input date as string
     * @param localization provides the date template the string is in via the format property
     */
    //eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "format",

    /**
     * Returns a string format.
     * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
     * for valid templates and locale objects
     * @param template An optional object. If provided, method will use Intl., otherwise the localizations format properties
     * @param locale Can be a string or an array of strings. Uses browser defaults otherwise.
     */
    value: function format(template) {
      var _this3 = this;

      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.localization.locale;
      if (template && _typeof(template) === 'object') return new Intl.DateTimeFormat(locale, template).format(this);
      var formatString = this.replaceTokens( //try template first
      template || //otherwise try localization format
      this.localization.format || //otherwise try date + time
      "".concat(DefaultFormatLocalization$1.dateFormats.L, ", ").concat(DefaultFormatLocalization$1.dateFormats.LT), this.localization.dateFormats);

      var formatter = function formatter(template) {
        return new Intl.DateTimeFormat(_this3.localization.locale, template).format(_this3);
      };

      if (!this.localization.hourCycle) this.localization.hourCycle = guessHourCycle(this.localization.locale); //if the format asks for a twenty-four-hour string but the hour cycle is not, then make a base guess

      var HHCycle = this.localization.hourCycle.startsWith('h1') ? 'h24' : this.localization.hourCycle;
      var hhCycle = this.localization.hourCycle.startsWith('h2') ? 'h12' : this.localization.hourCycle;
      var matches = {
        y: this.year,
        yy: formatter({
          year: '2-digit'
        }),
        yyyy: this.year,
        M: formatter({
          month: 'numeric'
        }),
        MM: this.monthFormatted,
        MMM: this.getAllMonths('short')[this.getMonth()],
        MMMM: this.getAllMonths()[this.getMonth()],
        d: this.date,
        dd: this.dateFormatted,
        ddd: formatter({
          weekday: 'short'
        }),
        dddd: formatter({
          weekday: 'long'
        }),
        H: this.getHours(),
        HH: this.getHoursFormatted(HHCycle),
        h: this.hours > 12 ? this.hours - 12 : this.hours,
        hh: this.getHoursFormatted(hhCycle),
        t: this.meridiem(),
        T: this.meridiem().toUpperCase(),
        m: this.minutes,
        mm: this.minutesFormatted,
        s: this.seconds,
        ss: this.secondsFormatted,
        fff: this.getMilliseconds() // z: this.zoneInformation(dateTime, 'z'), //-4
        // zz: this.zoneInformation(dateTime, 'zz'), //-04
        // zzz: this.zoneInformation(dateTime, 'zzz') //-0400

      };
      return formatString.replace(this.dateTimeRegex, function (match, $1) {
        return $1 || matches[match];
      }).replace(/\[/g, '').replace(/]/g, '');
    }
  }, {
    key: "clone",

    /**
     * Native date manipulations are not pure functions. This function creates a duplicate of the DateTime object.
     */
    get: function get() {
      return new DateTime(this.year, this.month, this.date, this.hours, this.minutes, this.seconds, this.getMilliseconds()).setLocalization(this.localization);
    }
  }, {
    key: "seconds",
    get: function get() {
      return this.getSeconds();
    }
    /**
     * Shortcut to Date.setSeconds()
     */
    ,
    set: function set(value) {
      this.setSeconds(value);
    }
    /**
     * Returns two digit hours
     */

  }, {
    key: "secondsFormatted",
    get: function get() {
      return this.parts(undefined, twoDigitTemplate).second;
    }
    /**
     * Shortcut to Date.getMinutes()
     */

  }, {
    key: "minutes",
    get: function get() {
      return this.getMinutes();
    }
    /**
     * Shortcut to Date.setMinutes()
     */
    ,
    set: function set(value) {
      this.setMinutes(value);
    }
    /**
     * Returns two digit minutes
     */

  }, {
    key: "minutesFormatted",
    get: function get() {
      return this.parts(undefined, twoDigitTemplate).minute;
    }
    /**
     * Shortcut to Date.getHours()
     */

  }, {
    key: "hours",
    get: function get() {
      return this.getHours();
    }
    /**
     * Shortcut to Date.setHours()
     */
    ,
    set: function set(value) {
      this.setHours(value);
    }
  }, {
    key: "date",
    get: function get() {
      return this.getDate();
    }
    /**
     * Shortcut to Date.setDate()
     */
    ,
    set: function set(value) {
      this.setDate(value);
    }
    /**
     * Return two digit date
     */

  }, {
    key: "dateFormatted",
    get: function get() {
      return this.parts(undefined, twoDigitTemplate).day;
    }
    /**
     * Shortcut to Date.getDay()
     */

  }, {
    key: "weekDay",
    get: function get() {
      return this.getDay();
    }
    /**
     * Shortcut to Date.getMonth()
     */

  }, {
    key: "month",
    get: function get() {
      return this.getMonth();
    }
    /**
     * Shortcut to Date.setMonth()
     */
    ,
    set: function set(value) {
      var targetMonth = new Date(this.year, value + 1);
      targetMonth.setDate(0);
      var endOfMonth = targetMonth.getDate();

      if (this.date > endOfMonth) {
        this.date = endOfMonth;
      }

      this.setMonth(value);
    }
    /**
     * Return two digit, human expected month. E.g. January = 1, December = 12
     */

  }, {
    key: "monthFormatted",
    get: function get() {
      return this.parts(undefined, twoDigitTemplate).month;
    }
    /**
     * Shortcut to Date.getFullYear()
     */

  }, {
    key: "year",
    get: function get() {
      return this.getFullYear();
    }
    /**
     * Shortcut to Date.setFullYear()
     */
    ,
    set: function set(value) {
      this.setFullYear(value);
    } // borrowed a bunch of stuff from Luxon

    /**
     * Gets the week of the year
     */

  }, {
    key: "week",
    get: function get() {
      var ordinal = this.computeOrdinal(),
          weekday = this.getUTCDay();
      var weekNumber = Math.floor((ordinal - weekday + 10) / 7);

      if (weekNumber < 1) {
        weekNumber = this.weeksInWeekYear();
      } else if (weekNumber > this.weeksInWeekYear()) {
        weekNumber = 1;
      }

      return weekNumber;
    }
  }, {
    key: "isLeapYear",
    get: function get() {
      return this.year % 4 === 0 && (this.year % 100 !== 0 || this.year % 400 === 0);
    }
  }], [{
    key: "convert",
    value: function convert(date) {
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      var formatLocalization = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      if (!date) throw new Error("A date is required");

      if (!formatLocalization) {
        formatLocalization = DefaultFormatLocalization$1;
        formatLocalization.locale = locale;
      }

      return new DateTime(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()).setLocalization(formatLocalization);
    }
  }, {
    key: "isValid",
    value: function isValid(d) {
      if (d === undefined || JSON.stringify(d) === 'null') return false;
      if (d.constructor.name === DateTime.name) return true;
      return false;
    }
  }, {
    key: "fromString",
    value: function fromString(input, localization) {
      if (!(localization === null || localization === void 0 ? void 0 : localization.format)) {
        Namespace.errorMessages.customDateFormatError('No format was provided');
      }

      try {
        var dt = new DateTime();
        dt.setLocalization(localization);
        if (['x', 'X'].indexOf(localization.format) > -1) return new DateTime((localization.format === 'X' ? 1000 : 1) * +input);
        input = input.replace(/\s+/g, ' ');
        var parser = dt.makeParser(localization.format);

        var _parser = parser(input),
            year = _parser.year,
            month = _parser.month,
            day = _parser.day,
            hours = _parser.hours,
            minutes = _parser.minutes,
            seconds = _parser.seconds,
            milliseconds = _parser.milliseconds,
            zone = _parser.zone;

        var d = day || (!year && !month ? dt.getDate() : 1);
        var y = year || dt.getFullYear();
        var M = 0;

        if (!(year && !month)) {
          M = month > 0 ? month - 1 : dt.getMonth();
        }

        if (zone) {
          return new DateTime(Date.UTC(y, M, d, hours, minutes, seconds, milliseconds + zone.offset * 60 * 1000));
        }

        return new DateTime(y, M, d, hours, minutes, seconds, milliseconds);
      } catch (e) {
        Namespace.errorMessages.customDateFormatError("Unable to parse provided input: ".concat(input, ", format: ").concat(localization.format));
      }
    }
  }]);

  return DateTime;
}( /*#__PURE__*/_wrapNativeSuper(Date));

var ServiceLocator = /*#__PURE__*/function () {
  function ServiceLocator() {
    _classCallCheck(this, ServiceLocator);

    this.cache = new Map();
  }

  _createClass(ServiceLocator, [{
    key: "locate",
    value: function locate(identifier) {
      var service = this.cache.get(identifier);
      if (service) return service;
      var value = new identifier();
      this.cache.set(identifier, value);
      return value;
    }
  }]);

  return ServiceLocator;
}();

var setupServiceLocator = function setupServiceLocator() {
  serviceLocator = new ServiceLocator();
};

var serviceLocator;
var CalendarModes = [{
  name: 'calendar',
  className: Namespace.css.daysContainer,
  unit: Unit.month,
  step: 1
}, {
  name: 'months',
  className: Namespace.css.monthsContainer,
  unit: Unit.year,
  step: 1
}, {
  name: 'years',
  className: Namespace.css.yearsContainer,
  unit: Unit.year,
  step: 10
}, {
  name: 'decades',
  className: Namespace.css.decadesContainer,
  unit: Unit.year,
  step: 100
}];

var OptionsStore = /*#__PURE__*/function () {
  function OptionsStore() {
    _classCallCheck(this, OptionsStore);

    this._currentCalendarViewMode = 0;
    this._viewDate = new DateTime();
    this.minimumCalendarViewMode = 0;
    this.currentView = 'calendar';
  }

  _createClass(OptionsStore, [{
    key: "refreshCurrentView",

    /**
     * When switching back to the calendar from the clock,
     * this sets currentView to the correct calendar view.
     */
    value: function refreshCurrentView() {
      this.currentView = CalendarModes[this.currentCalendarViewMode].name;
    }
  }, {
    key: "currentCalendarViewMode",
    get: function get() {
      return this._currentCalendarViewMode;
    },
    set: function set(value) {
      this._currentCalendarViewMode = value;
      this.currentView = CalendarModes[value].name;
    }
  }, {
    key: "viewDate",
    get: function get() {
      return this._viewDate;
    },
    set: function set(v) {
      this._viewDate = v;
      if (this.options) this.options.viewDate = v;
    }
  }, {
    key: "isTwelveHour",
    get: function get() {
      return ['h12', 'h11'].includes(this.options.localization.hourCycle);
    }
  }]);

  return OptionsStore;
}();
/**
 * Main class for date validation rules based on the options provided.
 */


var Validation = /*#__PURE__*/function () {
  function Validation() {
    _classCallCheck(this, Validation);

    this.optionsStore = serviceLocator.locate(OptionsStore);
  }
  /**
   * Checks to see if the target date is valid based on the rules provided in the options.
   * Granularity can be provided to check portions of the date instead of the whole.
   * @param targetDate
   * @param granularity
   */


  _createClass(Validation, [{
    key: "isValid",
    value: function isValid(targetDate, granularity) {
      var _this$optionsStore$op;

      if (!this._enabledDisabledDatesIsValid(granularity, targetDate)) return false;
      if (granularity !== Unit.month && granularity !== Unit.year && ((_this$optionsStore$op = this.optionsStore.options.restrictions.daysOfWeekDisabled) === null || _this$optionsStore$op === void 0 ? void 0 : _this$optionsStore$op.length) > 0 && this.optionsStore.options.restrictions.daysOfWeekDisabled.indexOf(targetDate.weekDay) !== -1) return false;
      if (!this._minMaxIsValid(granularity, targetDate)) return false;

      if (granularity === Unit.hours || granularity === Unit.minutes || granularity === Unit.seconds) {
        var _this$optionsStore$op2;

        if (!this._enabledDisabledHoursIsValid(targetDate)) return false;
        if (((_this$optionsStore$op2 = this.optionsStore.options.restrictions.disabledTimeIntervals) === null || _this$optionsStore$op2 === void 0 ? void 0 : _this$optionsStore$op2.filter(function (internal) {
          return targetDate.isBetween(internal.from, internal.to);
        }).length) !== 0) return false;
      }

      return true;
    }
  }, {
    key: "_enabledDisabledDatesIsValid",
    value: function _enabledDisabledDatesIsValid(granularity, targetDate) {
      if (granularity !== Unit.date) return true;

      if (this.optionsStore.options.restrictions.disabledDates.length > 0 && this._isInDisabledDates(targetDate)) {
        return false;
      } // noinspection RedundantIfStatementJS


      if (this.optionsStore.options.restrictions.enabledDates.length > 0 && !this._isInEnabledDates(targetDate)) {
        return false;
      }

      return true;
    }
    /**
     * Checks to see if the disabledDates option is in use and returns true (meaning invalid)
     * if the `testDate` is with in the array. Granularity is by date.
     * @param testDate
     * @private
     */

  }, {
    key: "_isInDisabledDates",
    value: function _isInDisabledDates(testDate) {
      if (!this.optionsStore.options.restrictions.disabledDates || this.optionsStore.options.restrictions.disabledDates.length === 0) return false;
      return !!this.optionsStore.options.restrictions.disabledDates.find(function (x) {
        return x.isSame(testDate, Unit.date);
      });
    }
    /**
     * Checks to see if the enabledDates option is in use and returns true (meaning valid)
     * if the `testDate` is with in the array. Granularity is by date.
     * @param testDate
     * @private
     */

  }, {
    key: "_isInEnabledDates",
    value: function _isInEnabledDates(testDate) {
      if (!this.optionsStore.options.restrictions.enabledDates || this.optionsStore.options.restrictions.enabledDates.length === 0) return true;
      return !!this.optionsStore.options.restrictions.enabledDates.find(function (x) {
        return x.isSame(testDate, Unit.date);
      });
    }
  }, {
    key: "_minMaxIsValid",
    value: function _minMaxIsValid(granularity, targetDate) {
      if (this.optionsStore.options.restrictions.minDate && targetDate.isBefore(this.optionsStore.options.restrictions.minDate, granularity)) {
        return false;
      } // noinspection RedundantIfStatementJS


      if (this.optionsStore.options.restrictions.maxDate && targetDate.isAfter(this.optionsStore.options.restrictions.maxDate, granularity)) {
        return false;
      }

      return true;
    }
  }, {
    key: "_enabledDisabledHoursIsValid",
    value: function _enabledDisabledHoursIsValid(targetDate) {
      if (this.optionsStore.options.restrictions.disabledHours.length > 0 && this._isInDisabledHours(targetDate)) {
        return false;
      } // noinspection RedundantIfStatementJS


      if (this.optionsStore.options.restrictions.enabledHours.length > 0 && !this._isInEnabledHours(targetDate)) {
        return false;
      }

      return true;
    }
    /**
     * Checks to see if the disabledHours option is in use and returns true (meaning invalid)
     * if the `testDate` is with in the array. Granularity is by hours.
     * @param testDate
     * @private
     */

  }, {
    key: "_isInDisabledHours",
    value: function _isInDisabledHours(testDate) {
      if (!this.optionsStore.options.restrictions.disabledHours || this.optionsStore.options.restrictions.disabledHours.length === 0) return false;
      var formattedDate = testDate.hours;
      return this.optionsStore.options.restrictions.disabledHours.includes(formattedDate);
    }
    /**
     * Checks to see if the enabledHours option is in use and returns true (meaning valid)
     * if the `testDate` is with in the array. Granularity is by hours.
     * @param testDate
     * @private
     */

  }, {
    key: "_isInEnabledHours",
    value: function _isInEnabledHours(testDate) {
      if (!this.optionsStore.options.restrictions.enabledHours || this.optionsStore.options.restrictions.enabledHours.length === 0) return true;
      var formattedDate = testDate.hours;
      return this.optionsStore.options.restrictions.enabledHours.includes(formattedDate);
    }
  }, {
    key: "dateRangeIsValid",
    value: function dateRangeIsValid(dates, index, target) {
      // if we're not using the option, then return valid
      if (!this.optionsStore.options.dateRange) return true; // if we've only selected 0..1 dates, and we're not setting the end date
      // then return valid. We only want to validate the range if both are selected,
      // because the other validation on the target has already occurred.

      if (dates.length !== 2 && index !== 1) return true; // initialize start date

      var start = dates[0].clone; // check if start date is not the same as target date

      if (start.isSame(target, Unit.date)) return true; // add one day to start; start has already been validated

      start.manipulate(1, Unit.date); // check each date in the range to make sure it's valid

      while (!start.isSame(target, Unit.date)) {
        var valid = this.isValid(start, Unit.date);
        if (!valid) return false;
        start.manipulate(1, Unit.date);
      }

      return true;
    }
  }]);

  return Validation;
}();

var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.subscribers = [];
  }

  _createClass(EventEmitter, [{
    key: "subscribe",
    value: function subscribe(callback) {
      this.subscribers.push(callback);
      return this.unsubscribe.bind(this, this.subscribers.length - 1);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(index) {
      this.subscribers.splice(index, 1);
    }
  }, {
    key: "emit",
    value: function emit(value) {
      this.subscribers.forEach(function (callback) {
        callback(value);
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.subscribers = null;
      this.subscribers = [];
    }
  }]);

  return EventEmitter;
}();

var EventEmitters = /*#__PURE__*/function () {
  function EventEmitters() {
    _classCallCheck(this, EventEmitters);

    this.triggerEvent = new EventEmitter();
    this.viewUpdate = new EventEmitter();
    this.updateDisplay = new EventEmitter();
    this.action = new EventEmitter(); //eslint-disable-line @typescript-eslint/no-explicit-any

    this.updateViewDate = new EventEmitter();
  }

  _createClass(EventEmitters, [{
    key: "destroy",
    value: function destroy() {
      this.triggerEvent.destroy();
      this.viewUpdate.destroy();
      this.updateDisplay.destroy();
      this.action.destroy();
      this.updateViewDate.destroy();
    }
  }]);

  return EventEmitters;
}();

var defaultEnLocalization = {
  clear: 'Clear selection',
  close: 'Close the picker',
  dateFormats: DefaultFormatLocalization$1.dateFormats,
  dayViewHeaderFormat: {
    month: 'long',
    year: '2-digit'
  },
  decrementHour: 'Decrement Hour',
  decrementMinute: 'Decrement Minute',
  decrementSecond: 'Decrement Second',
  format: DefaultFormatLocalization$1.format,
  hourCycle: DefaultFormatLocalization$1.hourCycle,
  incrementHour: 'Increment Hour',
  incrementMinute: 'Increment Minute',
  incrementSecond: 'Increment Second',
  locale: DefaultFormatLocalization$1.locale,
  maxWeekdayLength: 0,
  nextCentury: 'Next Century',
  nextDecade: 'Next Decade',
  nextMonth: 'Next Month',
  nextYear: 'Next Year',
  ordinal: DefaultFormatLocalization$1.ordinal,
  pickHour: 'Pick Hour',
  pickMinute: 'Pick Minute',
  pickSecond: 'Pick Second',
  previousCentury: 'Previous Century',
  previousDecade: 'Previous Decade',
  previousMonth: 'Previous Month',
  previousYear: 'Previous Year',
  selectDate: 'Select Date',
  selectDecade: 'Select Decade',
  selectMonth: 'Select Month',
  selectTime: 'Select Time',
  selectYear: 'Select Year',
  startOfTheWeek: 0,
  today: 'Go to today',
  toggleMeridiem: 'Toggle Meridiem'
};
var DefaultOptions = {
  allowInputToggle: false,
  container: undefined,
  dateRange: false,
  debug: false,
  defaultDate: undefined,
  display: {
    icons: {
      type: 'icons',
      time: 'fa-solid fa-clock',
      date: 'fa-solid fa-calendar',
      up: 'fa-solid fa-arrow-up',
      down: 'fa-solid fa-arrow-down',
      previous: 'fa-solid fa-chevron-left',
      next: 'fa-solid fa-chevron-right',
      today: 'fa-solid fa-calendar-check',
      clear: 'fa-solid fa-trash',
      close: 'fa-solid fa-xmark'
    },
    sideBySide: false,
    calendarWeeks: false,
    viewMode: 'calendar',
    toolbarPlacement: 'bottom',
    keepOpen: false,
    buttons: {
      today: false,
      clear: false,
      close: false
    },
    components: {
      calendar: true,
      date: true,
      month: true,
      year: true,
      decades: true,
      clock: true,
      hours: true,
      minutes: true,
      seconds: false,
      useTwentyfourHour: undefined
    },
    inline: false,
    theme: 'auto',
    placement: 'bottom'
  },
  keepInvalid: false,
  localization: defaultEnLocalization,
  meta: {},
  multipleDates: false,
  multipleDatesSeparator: '; ',
  promptTimeOnDateChange: false,
  promptTimeOnDateChangeTransitionDelay: 200,
  restrictions: {
    minDate: undefined,
    maxDate: undefined,
    disabledDates: [],
    enabledDates: [],
    daysOfWeekDisabled: [],
    disabledTimeIntervals: [],
    disabledHours: [],
    enabledHours: []
  },
  stepping: 1,
  useCurrent: true,
  viewDate: new DateTime()
};

var DefaultEnLocalization = _objectSpread({}, defaultEnLocalization);
/**
 * Attempts to prove `d` is a DateTime or Date or can be converted into one.
 * @param d If a string will attempt creating a date from it.
 * @param localization object containing locale and format settings. Only used with the custom formats
 * @private
 */


function tryConvertToDateTime(d, localization) {
  if (!d) return null;
  if (d.constructor.name === DateTime.name) return d;

  if (d.constructor.name === Date.name) {
    return DateTime.convert(d);
  }

  if (_typeof(d) === _typeof('')) {
    var dateTime = DateTime.fromString(d, localization);

    if (JSON.stringify(dateTime) === 'null') {
      return null;
    }

    return dateTime;
  }

  return null;
}
/**
 * Attempts to convert `d` to a DateTime object
 * @param d value to convert
 * @param optionName Provides text to error messages e.g. disabledDates
 * @param localization object containing locale and format settings. Only used with the custom formats
 */


function convertToDateTime(d, optionName, localization) {
  if (_typeof(d) === _typeof('') && optionName !== 'input') {
    Namespace.errorMessages.dateString();
  }

  var converted = tryConvertToDateTime(d, localization);

  if (!converted) {
    Namespace.errorMessages.failedToParseDate(optionName, d, optionName === 'input');
  }

  return converted;
}
/**
 * Type checks that `value` is an array of Date or DateTime
 * @param optionName Provides text to error messages e.g. disabledDates
 * @param value Option value
 * @param providedType Used to provide text to error messages
 * @param localization
 */


function typeCheckDateArray(optionName, value, //eslint-disable-line @typescript-eslint/no-explicit-any
providedType) {
  var localization = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DefaultFormatLocalization$1;

  if (!Array.isArray(value)) {
    Namespace.errorMessages.typeMismatch(optionName, providedType, 'array of DateTime or Date');
  }

  for (var i = 0; i < value.length; i++) {
    var d = value[i];
    var dateTime = convertToDateTime(d, optionName, localization);
    dateTime.setLocalization(localization);
    value[i] = dateTime;
  }
}
/**
 * Type checks that `value` is an array of numbers
 * @param optionName Provides text to error messages e.g. disabledDates
 * @param value Option value
 * @param providedType Used to provide text to error messages
 */


function typeCheckNumberArray(optionName, value, //eslint-disable-line @typescript-eslint/no-explicit-any
providedType) {
  if (!Array.isArray(value) || value.some(function (x) {
    return _typeof(x) !== _typeof(0);
  })) {
    Namespace.errorMessages.typeMismatch(optionName, providedType, 'array of numbers');
  }
}

function mandatoryDate(key) {
  return function (_ref) {
    var value = _ref.value,
        providedType = _ref.providedType,
        localization = _ref.localization;
    var dateTime = convertToDateTime(value, key, localization);

    if (dateTime !== undefined) {
      dateTime.setLocalization(localization);
      return dateTime;
    }
  };
}

function optionalDate(key) {
  var mandatory = mandatoryDate(key);
  return function (args) {
    if (args.value === undefined) {
      return args.value;
    }

    return mandatory(args);
  };
}

function numbersInRange(key, lower, upper) {
  return function (_ref2) {
    var value = _ref2.value,
        providedType = _ref2.providedType;

    if (value === undefined) {
      return [];
    }

    typeCheckNumberArray(key, value, providedType);
    if (value.some(function (x) {
      return x < lower || x > upper;
    })) Namespace.errorMessages.numbersOutOfRange(key, lower, upper);
    return value;
  };
}

function validHourRange(key) {
  return numbersInRange(key, 0, 23);
}

function validDateArray(key) {
  return function (_ref3) {
    var value = _ref3.value,
        providedType = _ref3.providedType,
        localization = _ref3.localization;

    if (value === undefined) {
      return [];
    }

    typeCheckDateArray(key, value, providedType, localization);
    return value;
  };
}

function validKeyOption(keyOptions) {
  return function (_ref4) {
    var value = _ref4.value,
        path = _ref4.path;
    if (!keyOptions.includes(value)) Namespace.errorMessages.unexpectedOptionValue(path.substring(1), value, keyOptions);
    return value;
  };
}

var optionProcessors = Object.freeze({
  defaultDate: mandatoryDate('defaultDate'),
  viewDate: mandatoryDate('viewDate'),
  minDate: optionalDate('restrictions.minDate'),
  maxDate: optionalDate('restrictions.maxDate'),
  disabledHours: validHourRange('restrictions.disabledHours'),
  enabledHours: validHourRange('restrictions.enabledHours'),
  disabledDates: validDateArray('restrictions.disabledDates'),
  enabledDates: validDateArray('restrictions.enabledDates'),
  daysOfWeekDisabled: numbersInRange('restrictions.daysOfWeekDisabled', 0, 6),
  disabledTimeIntervals: function disabledTimeIntervals(_ref5) {
    var key = _ref5.key,
        value = _ref5.value,
        providedType = _ref5.providedType,
        localization = _ref5.localization;

    if (value === undefined) {
      return [];
    }

    if (!Array.isArray(value)) {
      Namespace.errorMessages.typeMismatch(key, providedType, 'array of { from: DateTime|Date, to: DateTime|Date }');
    }

    var valueObject = value; //eslint-disable-line @typescript-eslint/no-explicit-any

    var _loop = function _loop(i) {
      Object.keys(valueObject[i]).forEach(function (vk) {
        var subOptionName = "".concat(key, "[").concat(i, "].").concat(vk);
        var d = valueObject[i][vk];
        var dateTime = convertToDateTime(d, subOptionName, localization);
        dateTime.setLocalization(localization);
        valueObject[i][vk] = dateTime;
      });
    };

    for (var i = 0; i < valueObject.length; i++) {
      _loop(i);
    }

    return valueObject;
  },
  toolbarPlacement: validKeyOption(['top', 'bottom', 'default']),
  type: validKeyOption(['icons', 'sprites']),
  viewMode: validKeyOption(['clock', 'calendar', 'months', 'years', 'decades']),
  theme: validKeyOption(['light', 'dark', 'auto']),
  placement: validKeyOption(['top', 'bottom']),
  meta: function meta(_ref6) {
    var value = _ref6.value;
    return value;
  },
  dayViewHeaderFormat: function dayViewHeaderFormat(_ref7) {
    var value = _ref7.value;
    return value;
  },
  container: function container(_ref8) {
    var value = _ref8.value,
        path = _ref8.path;

    if (value && !(value instanceof HTMLElement || value instanceof Element || (value === null || value === void 0 ? void 0 : value.appendChild))) {
      Namespace.errorMessages.typeMismatch(path.substring(1), _typeof(value), 'HTMLElement');
    }

    return value;
  },
  useTwentyfourHour: function useTwentyfourHour(_ref9) {
    var value = _ref9.value,
        path = _ref9.path,
        providedType = _ref9.providedType,
        defaultType = _ref9.defaultType;
    Namespace.errorMessages.deprecatedWarning('useTwentyfourHour', 'Please use "options.localization.hourCycle" instead');
    if (value === undefined || providedType === 'boolean') return value;
    Namespace.errorMessages.typeMismatch(path, providedType, defaultType);
  },
  hourCycle: validKeyOption(['h11', 'h12', 'h23', 'h24'])
});

var defaultProcessor = function defaultProcessor(_ref10) {
  var value = _ref10.value,
      defaultType = _ref10.defaultType,
      providedType = _ref10.providedType,
      path = _ref10.path;

  switch (defaultType) {
    case 'boolean':
      return value === 'true' || value === true;

    case 'number':
      return +value;

    case 'string':
      return value.toString();

    case 'object':
      return {};

    case 'function':
      return value;

    default:
      Namespace.errorMessages.typeMismatch(path, providedType, defaultType);
  }
};

function _processKey(args) {
  return (optionProcessors[args.key] || defaultProcessor)(args);
}

var OptionConverter = /*#__PURE__*/function () {
  function OptionConverter() {
    _classCallCheck(this, OptionConverter);
  }

  _createClass(OptionConverter, null, [{
    key: "deepCopy",
    value: function deepCopy(input) {
      var o = {};
      Object.keys(input).forEach(function (key) {
        var inputElement = input[key];

        if (inputElement instanceof DateTime) {
          o[key] = inputElement.clone;
          return;
        } else if (inputElement instanceof Date) {
          o[key] = new Date(inputElement.valueOf());
          return;
        }

        o[key] = inputElement;
        if (_typeof(inputElement) !== 'object' || inputElement instanceof HTMLElement || inputElement instanceof Element) return;

        if (!Array.isArray(inputElement)) {
          o[key] = OptionConverter.deepCopy(inputElement);
        }
      });
      return o;
    }
    /**
     * Finds value out of an object based on a string, period delimited, path
     * @param paths
     * @param obj
     */

  }, {
    key: "objectPath",
    value: function objectPath(paths, obj) {
      if (paths.charAt(0) === '.') paths = paths.slice(1);
      if (!paths) return obj;
      return paths.split('.').reduce(function (value, key) {
        return OptionConverter.isValue(value) || OptionConverter.isValue(value[key]) ? value[key] : undefined;
      }, obj);
    }
    /**
     * The spread operator caused sub keys to be missing after merging.
     * This is to fix that issue by using spread on the child objects first.
     * Also handles complex options like disabledDates
     * @param provided An option from new providedOptions
     * @param copyTo Destination object. This was added to prevent reference copies
     * @param localization
     * @param path
     */

  }, {
    key: "spread",
    value: function spread(provided, copyTo, localization) {
      var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var defaultOptions = OptionConverter.objectPath(path, DefaultOptions);
      var unsupportedOptions = Object.keys(provided).filter(function (x) {
        return !Object.keys(defaultOptions).includes(x);
      });

      if (unsupportedOptions.length > 0) {
        var flattenedOptions = OptionConverter.getFlattenDefaultOptions();
        var errors = unsupportedOptions.map(function (x) {
          var error = "\"".concat(path, ".").concat(x, "\" in not a known option.");
          var didYouMean = flattenedOptions.find(function (y) {
            return y.includes(x);
          });
          if (didYouMean) error += " Did you mean \"".concat(didYouMean, "\"?");
          return error;
        });
        Namespace.errorMessages.unexpectedOptions(errors);
      }

      Object.keys(provided).filter(function (key) {
        return key !== '__proto__' && key !== 'constructor';
      }).forEach(function (key) {
        path += ".".concat(key);
        if (path.charAt(0) === '.') path = path.slice(1);
        var defaultOptionValue = defaultOptions[key];

        var providedType = _typeof(provided[key]);

        var defaultType = _typeof(defaultOptionValue);

        var value = provided[key];

        if (value === undefined || value === null) {
          copyTo[key] = value;
          path = path.substring(0, path.lastIndexOf(".".concat(key)));
          return;
        }

        if (_typeof(defaultOptionValue) === 'object' && !Array.isArray(provided[key]) && !(defaultOptionValue instanceof Date || OptionConverter.ignoreProperties.includes(key))) {
          OptionConverter.spread(provided[key], copyTo[key], localization, path);
        } else {
          copyTo[key] = OptionConverter.processKey(key, value, providedType, defaultType, path, localization);
        }

        path = path.substring(0, path.lastIndexOf(".".concat(key)));
      });
    }
  }, {
    key: "processKey",
    value: function processKey(key, value, //eslint-disable-line @typescript-eslint/no-explicit-any
    providedType, defaultType, path, localization) {
      return _processKey({
        key: key,
        value: value,
        providedType: providedType,
        defaultType: defaultType,
        path: path,
        localization: localization
      });
    }
  }, {
    key: "_mergeOptions",
    value: function _mergeOptions(providedOptions, mergeTo) {
      var _mergeTo$localization;

      var newConfig = OptionConverter.deepCopy(mergeTo); //see if the options specify a locale

      var localization = ((_mergeTo$localization = mergeTo.localization) === null || _mergeTo$localization === void 0 ? void 0 : _mergeTo$localization.locale) !== 'default' ? mergeTo.localization : (providedOptions === null || providedOptions === void 0 ? void 0 : providedOptions.localization) || DefaultOptions.localization;
      OptionConverter.spread(providedOptions, newConfig, localization, '');
      return newConfig;
    }
  }, {
    key: "_dataToOptions",
    value: function _dataToOptions(element, options) {
      var eData = JSON.parse(JSON.stringify(element.dataset));
      if (eData === null || eData === void 0 ? void 0 : eData.tdTargetInput) delete eData.tdTargetInput;
      if (eData === null || eData === void 0 ? void 0 : eData.tdTargetToggle) delete eData.tdTargetToggle;
      if (!eData || Object.keys(eData).length === 0) return options;
      var dataOptions = {}; // because dataset returns camelCase including the 'td' key the option
      // key won't align

      var objectToNormalized = function objectToNormalized(object) {
        var lowered = {};
        Object.keys(object).forEach(function (x) {
          lowered[x.toLowerCase()] = x;
        });
        return lowered;
      };

      var normalizeObject = this.normalizeObject(objectToNormalized);
      var optionsLower = objectToNormalized(options);
      Object.keys(eData).filter(function (x) {
        return x.startsWith(Namespace.dataKey);
      }).map(function (x) {
        return x.substring(2);
      }).forEach(function (key) {
        var keyOption = optionsLower[key.toLowerCase()]; // dataset merges dashes to camelCase... yay
        // i.e. key = display_components_seconds

        if (key.includes('_')) {
          // [display, components, seconds]
          var split = key.split('_'); // display

          keyOption = optionsLower[split[0].toLowerCase()];

          if (keyOption !== undefined && options[keyOption].constructor === Object) {
            dataOptions[keyOption] = normalizeObject(split, 1, options[keyOption], eData["td".concat(key)]);
          }
        } // or key = multipleDate
        else if (keyOption !== undefined) {
            dataOptions[keyOption] = eData["td".concat(key)];
          }
      });
      return this._mergeOptions(dataOptions, options);
    } //todo clean this up

  }, {
    key: "normalizeObject",
    value: function normalizeObject(objectToNormalized) {
      var normalizeObject = function normalizeObject(split, index, optionSubgroup, value) {
        var _optionSubgroup$keyOp;

        // first round = display { ... }
        var normalizedOptions = objectToNormalized(optionSubgroup);
        var keyOption = normalizedOptions[split[index].toLowerCase()];
        var internalObject = {};
        if (keyOption === undefined) return internalObject; // if this is another object, continue down the rabbit hole

        if (((_optionSubgroup$keyOp = optionSubgroup[keyOption]) === null || _optionSubgroup$keyOp === void 0 ? void 0 : _optionSubgroup$keyOp.constructor) === Object) {
          index++;
          internalObject[keyOption] = normalizeObject(split, index, optionSubgroup[keyOption], value);
        } else {
          internalObject[keyOption] = value;
        }

        return internalObject;
      };

      return normalizeObject;
    }
    /**
     * Attempts to prove `d` is a DateTime or Date or can be converted into one.
     * @param d If a string will attempt creating a date from it.
     * @param localization object containing locale and format settings. Only used with the custom formats
     * @private
     */

  }, {
    key: "_dateTypeCheck",
    value: function _dateTypeCheck(d, //eslint-disable-line @typescript-eslint/no-explicit-any
    localization) {
      return tryConvertToDateTime(d, localization);
    }
    /**
     * Type checks that `value` is an array of Date or DateTime
     * @param optionName Provides text to error messages e.g. disabledDates
     * @param value Option value
     * @param providedType Used to provide text to error messages
     * @param localization
     */

  }, {
    key: "_typeCheckDateArray",
    value: function _typeCheckDateArray(optionName, value, providedType, localization) {
      return typeCheckDateArray(optionName, value, providedType, localization);
    }
    /**
     * Type checks that `value` is an array of numbers
     * @param optionName Provides text to error messages e.g. disabledDates
     * @param value Option value
     * @param providedType Used to provide text to error messages
     */

  }, {
    key: "_typeCheckNumberArray",
    value: function _typeCheckNumberArray(optionName, value, providedType) {
      return typeCheckNumberArray(optionName, value, providedType);
    }
    /**
     * Attempts to convert `d` to a DateTime object
     * @param d value to convert
     * @param optionName Provides text to error messages e.g. disabledDates
     * @param localization object containing locale and format settings. Only used with the custom formats
     */

  }, {
    key: "dateConversion",
    value: function dateConversion(d, //eslint-disable-line @typescript-eslint/no-explicit-any
    optionName, localization) {
      return convertToDateTime(d, optionName, localization);
    }
  }, {
    key: "getFlattenDefaultOptions",
    value: function getFlattenDefaultOptions() {
      if (this._flattenDefaults) return this._flattenDefaults;

      var deepKeys = function deepKeys(t) {
        var pre = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        if (Array.isArray(t)) return [];

        if (Object(t) === t) {
          return Object.entries(t).flatMap(function (_ref11) {
            var _ref12 = _slicedToArray(_ref11, 2),
                k = _ref12[0],
                v = _ref12[1];

            return deepKeys(v, [].concat(_toConsumableArray(pre), [k]));
          });
        } else {
          return pre.join('.');
        }
      };

      this._flattenDefaults = deepKeys(DefaultOptions);
      return this._flattenDefaults;
    }
    /**
     * Some options conflict like min/max date. Verify that these kinds of options
     * are set correctly.
     * @param config
     */

  }, {
    key: "_validateConflicts",
    value: function _validateConflicts(config) {
      if (config.display.sideBySide && (!config.display.components.clock || !(config.display.components.hours || config.display.components.minutes || config.display.components.seconds))) {
        Namespace.errorMessages.conflictingConfiguration('Cannot use side by side mode without the clock components');
      }

      if (config.restrictions.minDate && config.restrictions.maxDate) {
        if (config.restrictions.minDate.isAfter(config.restrictions.maxDate)) {
          Namespace.errorMessages.conflictingConfiguration('minDate is after maxDate');
        }

        if (config.restrictions.maxDate.isBefore(config.restrictions.minDate)) {
          Namespace.errorMessages.conflictingConfiguration('maxDate is before minDate');
        }
      }

      if (config.multipleDates && config.dateRange) {
        Namespace.errorMessages.conflictingConfiguration('Cannot uss option "multipleDates" with "dateRange"');
      }
    }
  }]);

  return OptionConverter;
}();

OptionConverter.ignoreProperties = ['meta', 'dayViewHeaderFormat', 'container', 'dateForms', 'ordinal'];

OptionConverter.isValue = function (a) {
  return a != null;
}; // everything except undefined + null


var Dates = /*#__PURE__*/function () {
  function Dates() {
    _classCallCheck(this, Dates);

    this._dates = [];
    this.optionsStore = serviceLocator.locate(OptionsStore);
    this.validation = serviceLocator.locate(Validation);
    this._eventEmitters = serviceLocator.locate(EventEmitters);
  }
  /**
   * Returns the array of selected dates
   */


  _createClass(Dates, [{
    key: "formatInput",

    /**
     * Formats a DateTime object to a string. Used when setting the input value.
     * @param date
     */
    value: function formatInput(date) {
      if (!date) return '';
      date.localization = this.optionsStore.options.localization;
      return date.format();
    }
    /**
     * parse the value into a DateTime object.
     * this can be overwritten to supply your own parsing.
     */
    //eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "parseInput",
    value: function parseInput(value) {
      try {
        return OptionConverter.dateConversion(value, 'input', this.optionsStore.options.localization);
      } catch (e) {
        this._eventEmitters.triggerEvent.emit({
          type: Namespace.events.error,
          reason: Namespace.errorMessages.failedToParseInput,
          format: this.optionsStore.options.localization.format,
          value: value
        });

        return undefined;
      }
    }
    /**
     * Tries to convert the provided value to a DateTime object.
     * If value is null|undefined then clear the value of the provided index (or 0).
     * @param value Value to convert or null|undefined
     * @param index When using multidates this is the index in the array
     */
    //eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "setFromInput",
    value: function setFromInput(value, index) {
      if (!value) {
        this.setValue(undefined, index);
        return;
      }

      var converted = this.parseInput(value);

      if (converted) {
        converted.setLocalization(this.optionsStore.options.localization);
        this.setValue(converted, index);
      }
    }
    /**
     * Adds a new DateTime to selected dates array
     * @param date
     */

  }, {
    key: "add",
    value: function add(date) {
      this._dates.push(date);
    }
    /**
     * Returns true if the `targetDate` is part of the selected dates array.
     * If `unit` is provided then a granularity to that unit will be used.
     * @param targetDate
     * @param unit
     */

  }, {
    key: "isPicked",
    value: function isPicked(targetDate, unit) {
      if (!DateTime.isValid(targetDate)) return false;
      if (!unit) return this._dates.find(function (x) {
        return x.isSame(targetDate);
      }) !== undefined;
      var format = getFormatByUnit(unit);
      var innerDateFormatted = targetDate.format(format);
      return this._dates.map(function (x) {
        return x.format(format);
      }).find(function (x) {
        return x === innerDateFormatted;
      }) !== undefined;
    }
    /**
     * Returns the index at which `targetDate` is in the array.
     * This is used for updating or removing a date when multi-date is used
     * If `unit` is provided then a granularity to that unit will be used.
     * @param targetDate
     * @param unit
     */

  }, {
    key: "pickedIndex",
    value: function pickedIndex(targetDate, unit) {
      if (!DateTime.isValid(targetDate)) return -1;
      if (!unit) return this._dates.map(function (x) {
        return x.valueOf();
      }).indexOf(targetDate.valueOf());
      var format = getFormatByUnit(unit);
      var innerDateFormatted = targetDate.format(format);
      return this._dates.map(function (x) {
        return x.format(format);
      }).indexOf(innerDateFormatted);
    }
    /**
     * Clears all selected dates.
     */

  }, {
    key: "clear",
    value: function clear() {
      this.optionsStore.unset = true;

      this._eventEmitters.triggerEvent.emit({
        type: Namespace.events.change,
        date: undefined,
        oldDate: this.lastPicked,
        isClear: true,
        isValid: true
      });

      this._dates = [];
      if (this.optionsStore.input) this.optionsStore.input.value = '';

      this._eventEmitters.updateDisplay.emit('all');
    }
    /**
     * Find the "book end" years given a `year` and a `factor`
     * @param factor e.g. 100 for decades
     * @param year e.g. 2021
     */

  }, {
    key: "updateInput",
    value: function updateInput(target) {
      var _this4 = this;

      if (!this.optionsStore.input) return;
      var newValue = this.formatInput(target);

      if (this.optionsStore.options.multipleDates || this.optionsStore.options.dateRange) {
        newValue = this._dates.map(function (d) {
          return _this4.formatInput(d);
        }).join(this.optionsStore.options.multipleDatesSeparator);
      }

      if (this.optionsStore.input.value != newValue) this.optionsStore.input.value = newValue;
    }
    /**
     * Attempts to either clear or set the `target` date at `index`.
     * If the `target` is null then the date will be cleared.
     * If multi-date is being used then it will be removed from the array.
     * If `target` is valid and multi-date is used then if `index` is
     * provided the date at that index will be replaced, otherwise it is appended.
     * @param target
     * @param index
     */

  }, {
    key: "setValue",
    value: function setValue(target, index) {
      var _this$_dates$index,
          _oldDate,
          _this5 = this;

      var noIndex = typeof index === 'undefined',
          isClear = !target && noIndex;
      var oldDate = this.optionsStore.unset ? null : (_this$_dates$index = this._dates[index]) === null || _this$_dates$index === void 0 ? void 0 : _this$_dates$index.clone;

      if (!oldDate && !this.optionsStore.unset && noIndex && isClear) {
        oldDate = this.lastPicked;
      }

      if (target && ((_oldDate = oldDate) === null || _oldDate === void 0 ? void 0 : _oldDate.isSame(target))) {
        this.updateInput(target);
        return;
      } // case of calling setValue(null)


      if (!target) {
        this._setValueNull(isClear, index, oldDate);

        return;
      }

      index = index || 0;
      target = target.clone; // minute stepping is being used, force the minute to the closest value

      if (this.optionsStore.options.stepping !== 1) {
        target.minutes = Math.round(target.minutes / this.optionsStore.options.stepping) * this.optionsStore.options.stepping;
        target.startOf(Unit.minutes);
      }

      var onUpdate = function onUpdate(isValid) {
        _this5._dates[index] = target;

        _this5._eventEmitters.updateViewDate.emit(target.clone);

        _this5.updateInput(target);

        _this5.optionsStore.unset = false;

        _this5._eventEmitters.updateDisplay.emit('all');

        _this5._eventEmitters.triggerEvent.emit({
          type: Namespace.events.change,
          date: target,
          oldDate: oldDate,
          isClear: isClear,
          isValid: isValid
        });
      };

      if (this.validation.isValid(target) && this.validation.dateRangeIsValid(this.picked, index, target)) {
        onUpdate(true);
        return;
      }

      if (this.optionsStore.options.keepInvalid) {
        onUpdate(false);
      }

      this._eventEmitters.triggerEvent.emit({
        type: Namespace.events.error,
        reason: Namespace.errorMessages.failedToSetInvalidDate,
        date: target,
        oldDate: oldDate
      });
    }
  }, {
    key: "_setValueNull",
    value: function _setValueNull(isClear, index, oldDate) {
      if (!this.optionsStore.options.multipleDates || this._dates.length === 1 || isClear) {
        this.optionsStore.unset = true;
        this._dates = [];
      } else {
        this._dates.splice(index, 1);
      }

      this.updateInput();

      this._eventEmitters.triggerEvent.emit({
        type: Namespace.events.change,
        date: undefined,
        oldDate: oldDate,
        isClear: isClear,
        isValid: true
      });

      this._eventEmitters.updateDisplay.emit('all');
    }
  }, {
    key: "picked",
    get: function get() {
      return _toConsumableArray(this._dates);
    }
    /**
     * Returns the last picked value.
     */

  }, {
    key: "lastPicked",
    get: function get() {
      var _this$_dates$this$las;

      return (_this$_dates$this$las = this._dates[this.lastPickedIndex]) === null || _this$_dates$this$las === void 0 ? void 0 : _this$_dates$this$las.clone;
    }
    /**
     * Returns the length of picked dates -1 or 0 if none are selected.
     */

  }, {
    key: "lastPickedIndex",
    get: function get() {
      if (this._dates.length === 0) return 0;
      return this._dates.length - 1;
    }
  }], [{
    key: "getStartEndYear",
    value: function getStartEndYear(factor, year) {
      var step = factor / 10,
          startYear = Math.floor(year / factor) * factor,
          endYear = startYear + step * 9,
          focusValue = Math.floor(year / step) * step;
      return [startYear, endYear, focusValue];
    }
  }]);

  return Dates;
}();

var ActionTypes;

(function (ActionTypes) {
  ActionTypes["next"] = "next";
  ActionTypes["previous"] = "previous";
  ActionTypes["changeCalendarView"] = "changeCalendarView";
  ActionTypes["selectMonth"] = "selectMonth";
  ActionTypes["selectYear"] = "selectYear";
  ActionTypes["selectDecade"] = "selectDecade";
  ActionTypes["selectDay"] = "selectDay";
  ActionTypes["selectHour"] = "selectHour";
  ActionTypes["selectMinute"] = "selectMinute";
  ActionTypes["selectSecond"] = "selectSecond";
  ActionTypes["incrementHours"] = "incrementHours";
  ActionTypes["incrementMinutes"] = "incrementMinutes";
  ActionTypes["incrementSeconds"] = "incrementSeconds";
  ActionTypes["decrementHours"] = "decrementHours";
  ActionTypes["decrementMinutes"] = "decrementMinutes";
  ActionTypes["decrementSeconds"] = "decrementSeconds";
  ActionTypes["toggleMeridiem"] = "toggleMeridiem";
  ActionTypes["togglePicker"] = "togglePicker";
  ActionTypes["showClock"] = "showClock";
  ActionTypes["showHours"] = "showHours";
  ActionTypes["showMinutes"] = "showMinutes";
  ActionTypes["showSeconds"] = "showSeconds";
  ActionTypes["clear"] = "clear";
  ActionTypes["close"] = "close";
  ActionTypes["today"] = "today";
})(ActionTypes || (ActionTypes = {}));

var ActionTypes$1 = ActionTypes;
/**
 * Creates and updates the grid for `date`
 */

var DateDisplay = /*#__PURE__*/function () {
  function DateDisplay() {
    _classCallCheck(this, DateDisplay);

    this.optionsStore = serviceLocator.locate(OptionsStore);
    this.dates = serviceLocator.locate(Dates);
    this.validation = serviceLocator.locate(Validation);
  }
  /**
   * Build the container html for the display
   * @private
   */


  _createClass(DateDisplay, [{
    key: "getPicker",
    value: function getPicker() {
      var container = document.createElement('div');
      container.classList.add(Namespace.css.daysContainer);
      container.append.apply(container, _toConsumableArray(this._daysOfTheWeek()));

      if (this.optionsStore.options.display.calendarWeeks) {
        var div = document.createElement('div');
        div.classList.add(Namespace.css.calendarWeeks, Namespace.css.noHighlight);
        container.appendChild(div);
      }

      var _this$handleMouseEven = this.handleMouseEvents(container),
          rangeHoverEvent = _this$handleMouseEven.rangeHoverEvent,
          rangeHoverOutEvent = _this$handleMouseEven.rangeHoverOutEvent;

      for (var i = 0; i < 42; i++) {
        if (i !== 0 && i % 7 === 0) {
          if (this.optionsStore.options.display.calendarWeeks) {
            var _div2 = document.createElement('div');

            _div2.classList.add(Namespace.css.calendarWeeks, Namespace.css.noHighlight);

            container.appendChild(_div2);
          }
        }

        var _div = document.createElement('div');

        _div.setAttribute('data-action', ActionTypes$1.selectDay);

        container.appendChild(_div); // if hover is supported then add the events

        if (matchMedia('(hover: hover)').matches && this.optionsStore.options.dateRange) {
          _div.addEventListener('mouseover', rangeHoverEvent);

          _div.addEventListener('mouseout', rangeHoverOutEvent);
        }
      }

      return container;
    }
    /**
     * Populates the grid and updates enabled states
     * @private
     */

  }, {
    key: "_update",
    value: function _update(widget, paint) {
      var _this6 = this;

      var container = widget.getElementsByClassName(Namespace.css.daysContainer)[0];

      this._updateCalendarView(container);

      var innerDate = this.optionsStore.viewDate.clone.startOf(Unit.month).startOf('weekDay', this.optionsStore.options.localization.startOfTheWeek).manipulate(12, Unit.hours);

      this._handleCalendarWeeks(container, innerDate.clone);

      container.querySelectorAll("[data-action=\"".concat(ActionTypes$1.selectDay, "\"]")).forEach(function (element) {
        var _element$classList, _element$classList2;

        var classes = [];
        classes.push(Namespace.css.day);

        if (innerDate.isBefore(_this6.optionsStore.viewDate, Unit.month)) {
          classes.push(Namespace.css.old);
        }

        if (innerDate.isAfter(_this6.optionsStore.viewDate, Unit.month)) {
          classes.push(Namespace.css.new);
        }

        if (!_this6.optionsStore.unset && !_this6.optionsStore.options.dateRange && _this6.dates.isPicked(innerDate, Unit.date)) {
          classes.push(Namespace.css.active);
        }

        if (!_this6.validation.isValid(innerDate, Unit.date)) {
          classes.push(Namespace.css.disabled);
        }

        if (innerDate.isSame(new DateTime(), Unit.date)) {
          classes.push(Namespace.css.today);
        }

        if (innerDate.weekDay === 0 || innerDate.weekDay === 6) {
          classes.push(Namespace.css.weekend);
        }

        _this6._handleDateRange(innerDate, classes);

        paint(Unit.date, innerDate, classes, element);

        (_element$classList = element.classList).remove.apply(_element$classList, _toConsumableArray(element.classList));

        (_element$classList2 = element.classList).add.apply(_element$classList2, classes);

        element.setAttribute('data-value', _this6._dateToDataValue(innerDate));
        element.setAttribute('data-day', "".concat(innerDate.date));
        element.innerText = innerDate.parts(undefined, {
          day: 'numeric'
        }).day;
        innerDate.manipulate(1, Unit.date);
      });
    }
  }, {
    key: "_dateToDataValue",
    value: function _dateToDataValue(date) {
      if (!DateTime.isValid(date)) return '';
      return "".concat(date.year, "-").concat(date.month.toString().padStart(2, '0'), "-").concat(date.date.toString().padStart(2, '0'));
    }
  }, {
    key: "_handleDateRange",
    value: function _handleDateRange(innerDate, classes) {
      var rangeStart = this.dates.picked[0];
      var rangeEnd = this.dates.picked[1];

      if (this.optionsStore.options.dateRange) {
        if (innerDate.isBetween(rangeStart, rangeEnd, Unit.date)) {
          classes.push(Namespace.css.rangeIn);
        }

        if (innerDate.isSame(rangeStart, Unit.date)) {
          classes.push(Namespace.css.rangeStart);
        }

        if (innerDate.isSame(rangeEnd, Unit.date)) {
          classes.push(Namespace.css.rangeEnd);
        }
      }
    }
  }, {
    key: "handleMouseEvents",
    value: function handleMouseEvents(container) {
      var _this7 = this;

      var rangeHoverEvent = function rangeHoverEvent(e) {
        var currentTarget = e === null || e === void 0 ? void 0 : e.currentTarget; // if we have 0 or 2 selected or if the target is disabled then ignore

        if (_this7.dates.picked.length !== 1 || currentTarget.classList.contains(Namespace.css.disabled)) return; // select all the date divs

        var allDays = _toConsumableArray(container.querySelectorAll('.day')); // get the date value from the element being hovered over


        var attributeValue = currentTarget.getAttribute('data-value'); // format the string to a date

        var innerDate = DateTime.fromString(attributeValue, {
          format: 'yyyy-MM-dd'
        }); // find the position of the target in the date container

        var dayIndex = allDays.findIndex(function (e) {
          return e.getAttribute('data-value') === attributeValue;
        }); // find the first and second selected dates

        var rangeStart = _this7.dates.picked[0];
        var rangeEnd = _this7.dates.picked[1]; //format the start date so that it can be found by the attribute

        var rangeStartFormatted = _this7._dateToDataValue(rangeStart);

        var rangeStartIndex = allDays.findIndex(function (e) {
          return e.getAttribute('data-value') === rangeStartFormatted;
        });
        var rangeStartElement = allDays[rangeStartIndex]; //make sure we don't leave start/end classes if we don't need them

        if (!innerDate.isSame(rangeStart, Unit.date)) {
          currentTarget.classList.remove(Namespace.css.rangeStart);
        }

        if (!innerDate.isSame(rangeEnd, Unit.date)) {
          currentTarget.classList.remove(Namespace.css.rangeEnd);
        } // the following figures out which direct from start date is selected
        // the selection "cap" classes are applied if needed
        // otherwise all the dates between will get the `rangeIn` class.
        // We make this selection based on the element's index and the rangeStart index


        var lambda;

        if (innerDate.isBefore(rangeStart)) {
          currentTarget.classList.add(Namespace.css.rangeStart);
          rangeStartElement === null || rangeStartElement === void 0 ? void 0 : rangeStartElement.classList.remove(Namespace.css.rangeStart);
          rangeStartElement === null || rangeStartElement === void 0 ? void 0 : rangeStartElement.classList.add(Namespace.css.rangeEnd);

          lambda = function lambda(_, index) {
            return index > dayIndex && index < rangeStartIndex;
          };
        } else {
          currentTarget.classList.add(Namespace.css.rangeEnd);
          rangeStartElement === null || rangeStartElement === void 0 ? void 0 : rangeStartElement.classList.remove(Namespace.css.rangeEnd);
          rangeStartElement === null || rangeStartElement === void 0 ? void 0 : rangeStartElement.classList.add(Namespace.css.rangeStart);

          lambda = function lambda(_, index) {
            return index < dayIndex && index > rangeStartIndex;
          };
        }

        allDays.filter(lambda).forEach(function (e) {
          e.classList.add(Namespace.css.rangeIn);
        });
      };

      var rangeHoverOutEvent = function rangeHoverOutEvent(e) {
        // find all the dates in the container
        var allDays = _toConsumableArray(container.querySelectorAll('.day')); // if only the start is selected, remove all the rangeIn classes
        // we do this because once the user hovers over a new date the range will be recalculated.


        if (_this7.dates.picked.length === 1) allDays.forEach(function (e) {
          return e.classList.remove(Namespace.css.rangeIn);
        }); // if we have 0 or 2 dates selected then ignore

        if (_this7.dates.picked.length !== 1) return;
        var currentTarget = e === null || e === void 0 ? void 0 : e.currentTarget; // get the elements date from the attribute value

        var innerDate = new DateTime(currentTarget.getAttribute('data-value')); // verify selections and remove invalid classes

        if (!innerDate.isSame(_this7.dates.picked[0], Unit.date)) {
          currentTarget.classList.remove(Namespace.css.rangeStart);
        }

        if (!innerDate.isSame(_this7.dates.picked[1], Unit.date)) {
          currentTarget.classList.remove(Namespace.css.rangeEnd);
        }
      };

      return {
        rangeHoverEvent: rangeHoverEvent,
        rangeHoverOutEvent: rangeHoverOutEvent
      };
    }
  }, {
    key: "_updateCalendarView",
    value: function _updateCalendarView(container) {
      if (this.optionsStore.currentView !== 'calendar') return;

      var _container$parentElem = container.parentElement.getElementsByClassName(Namespace.css.calendarHeader)[0].getElementsByTagName('div'),
          _container$parentElem2 = _slicedToArray(_container$parentElem, 3),
          previous = _container$parentElem2[0],
          switcher = _container$parentElem2[1],
          next = _container$parentElem2[2];

      switcher.setAttribute(Namespace.css.daysContainer, this.optionsStore.viewDate.format(this.optionsStore.options.localization.dayViewHeaderFormat));
      this.optionsStore.options.display.components.month ? switcher.classList.remove(Namespace.css.disabled) : switcher.classList.add(Namespace.css.disabled);
      this.validation.isValid(this.optionsStore.viewDate.clone.manipulate(-1, Unit.month), Unit.month) ? previous.classList.remove(Namespace.css.disabled) : previous.classList.add(Namespace.css.disabled);
      this.validation.isValid(this.optionsStore.viewDate.clone.manipulate(1, Unit.month), Unit.month) ? next.classList.remove(Namespace.css.disabled) : next.classList.add(Namespace.css.disabled);
    }
    /***
     * Generates a html row that contains the days of the week.
     * @private
     */

  }, {
    key: "_daysOfTheWeek",
    value: function _daysOfTheWeek() {
      var innerDate = this.optionsStore.viewDate.clone.startOf('weekDay', this.optionsStore.options.localization.startOfTheWeek).startOf(Unit.date);
      var row = [];
      document.createElement('div');

      if (this.optionsStore.options.display.calendarWeeks) {
        var htmlDivElement = document.createElement('div');
        htmlDivElement.classList.add(Namespace.css.calendarWeeks, Namespace.css.noHighlight);
        htmlDivElement.innerText = '#';
        row.push(htmlDivElement);
      }

      for (var i = 0; i < 7; i++) {
        var _htmlDivElement = document.createElement('div');

        _htmlDivElement.classList.add(Namespace.css.dayOfTheWeek, Namespace.css.noHighlight);

        var weekDay = innerDate.format({
          weekday: 'short'
        });
        if (this.optionsStore.options.localization.maxWeekdayLength > 0) weekDay = weekDay.substring(0, this.optionsStore.options.localization.maxWeekdayLength);
        _htmlDivElement.innerText = weekDay;
        innerDate.manipulate(1, Unit.date);
        row.push(_htmlDivElement);
      }

      return row;
    }
  }, {
    key: "_handleCalendarWeeks",
    value: function _handleCalendarWeeks(container, innerDate) {
      _toConsumableArray(container.querySelectorAll(".".concat(Namespace.css.calendarWeeks))).filter(function (e) {
        return e.innerText !== '#';
      }).forEach(function (element) {
        element.innerText = "".concat(innerDate.week);
        innerDate.manipulate(7, Unit.date);
      });
    }
  }]);

  return DateDisplay;
}();
/**
 * Creates and updates the grid for `month`
 */


var MonthDisplay = /*#__PURE__*/function () {
  function MonthDisplay() {
    _classCallCheck(this, MonthDisplay);

    this.optionsStore = serviceLocator.locate(OptionsStore);
    this.dates = serviceLocator.locate(Dates);
    this.validation = serviceLocator.locate(Validation);
  }
  /**
   * Build the container html for the display
   * @private
   */


  _createClass(MonthDisplay, [{
    key: "getPicker",
    value: function getPicker() {
      var container = document.createElement('div');
      container.classList.add(Namespace.css.monthsContainer);

      for (var i = 0; i < 12; i++) {
        var div = document.createElement('div');
        div.setAttribute('data-action', ActionTypes$1.selectMonth);
        container.appendChild(div);
      }

      return container;
    }
    /**
     * Populates the grid and updates enabled states
     * @private
     */

  }, {
    key: "_update",
    value: function _update(widget, paint) {
      var _this8 = this;

      var container = widget.getElementsByClassName(Namespace.css.monthsContainer)[0];

      if (this.optionsStore.currentView === 'months') {
        var _container$parentElem3 = container.parentElement.getElementsByClassName(Namespace.css.calendarHeader)[0].getElementsByTagName('div'),
            _container$parentElem4 = _slicedToArray(_container$parentElem3, 3),
            previous = _container$parentElem4[0],
            switcher = _container$parentElem4[1],
            next = _container$parentElem4[2];

        switcher.setAttribute(Namespace.css.monthsContainer, this.optionsStore.viewDate.format({
          year: 'numeric'
        }));
        this.optionsStore.options.display.components.year ? switcher.classList.remove(Namespace.css.disabled) : switcher.classList.add(Namespace.css.disabled);
        this.validation.isValid(this.optionsStore.viewDate.clone.manipulate(-1, Unit.year), Unit.year) ? previous.classList.remove(Namespace.css.disabled) : previous.classList.add(Namespace.css.disabled);
        this.validation.isValid(this.optionsStore.viewDate.clone.manipulate(1, Unit.year), Unit.year) ? next.classList.remove(Namespace.css.disabled) : next.classList.add(Namespace.css.disabled);
      }

      var innerDate = this.optionsStore.viewDate.clone.startOf(Unit.year);
      container.querySelectorAll("[data-action=\"".concat(ActionTypes$1.selectMonth, "\"]")).forEach(function (containerClone, index) {
        var _containerClone$class, _containerClone$class2;

        var classes = [];
        classes.push(Namespace.css.month);

        if (!_this8.optionsStore.unset && _this8.dates.isPicked(innerDate, Unit.month)) {
          classes.push(Namespace.css.active);
        }

        if (!_this8.validation.isValid(innerDate, Unit.month)) {
          classes.push(Namespace.css.disabled);
        }

        paint(Unit.month, innerDate, classes, containerClone);

        (_containerClone$class = containerClone.classList).remove.apply(_containerClone$class, _toConsumableArray(containerClone.classList));

        (_containerClone$class2 = containerClone.classList).add.apply(_containerClone$class2, classes);

        containerClone.setAttribute('data-value', "".concat(index));
        containerClone.innerText = "".concat(innerDate.format({
          month: 'short'
        }));
        innerDate.manipulate(1, Unit.month);
      });
    }
  }]);

  return MonthDisplay;
}();
/**
 * Creates and updates the grid for `year`
 */


var YearDisplay = /*#__PURE__*/function () {
  function YearDisplay() {
    _classCallCheck(this, YearDisplay);

    this.optionsStore = serviceLocator.locate(OptionsStore);
    this.dates = serviceLocator.locate(Dates);
    this.validation = serviceLocator.locate(Validation);
  }
  /**
   * Build the container html for the display
   * @private
   */


  _createClass(YearDisplay, [{
    key: "getPicker",
    value: function getPicker() {
      var container = document.createElement('div');
      container.classList.add(Namespace.css.yearsContainer);

      for (var i = 0; i < 12; i++) {
        var div = document.createElement('div');
        div.setAttribute('data-action', ActionTypes$1.selectYear);
        container.appendChild(div);
      }

      return container;
    }
    /**
     * Populates the grid and updates enabled states
     * @private
     */

  }, {
    key: "_update",
    value: function _update(widget, paint) {
      var _this9 = this;

      this._startYear = this.optionsStore.viewDate.clone.manipulate(-1, Unit.year);
      this._endYear = this.optionsStore.viewDate.clone.manipulate(10, Unit.year);
      var container = widget.getElementsByClassName(Namespace.css.yearsContainer)[0];

      if (this.optionsStore.currentView === 'years') {
        var _container$parentElem5 = container.parentElement.getElementsByClassName(Namespace.css.calendarHeader)[0].getElementsByTagName('div'),
            _container$parentElem6 = _slicedToArray(_container$parentElem5, 3),
            previous = _container$parentElem6[0],
            switcher = _container$parentElem6[1],
            next = _container$parentElem6[2];

        switcher.setAttribute(Namespace.css.yearsContainer, "".concat(this._startYear.format({
          year: 'numeric'
        }), "-").concat(this._endYear.format({
          year: 'numeric'
        })));
        this.optionsStore.options.display.components.decades ? switcher.classList.remove(Namespace.css.disabled) : switcher.classList.add(Namespace.css.disabled);
        this.validation.isValid(this._startYear, Unit.year) ? previous.classList.remove(Namespace.css.disabled) : previous.classList.add(Namespace.css.disabled);
        this.validation.isValid(this._endYear, Unit.year) ? next.classList.remove(Namespace.css.disabled) : next.classList.add(Namespace.css.disabled);
      }

      var innerDate = this.optionsStore.viewDate.clone.startOf(Unit.year).manipulate(-1, Unit.year);
      container.querySelectorAll("[data-action=\"".concat(ActionTypes$1.selectYear, "\"]")).forEach(function (containerClone) {
        var _containerClone$class3, _containerClone$class4;

        var classes = [];
        classes.push(Namespace.css.year);

        if (!_this9.optionsStore.unset && _this9.dates.isPicked(innerDate, Unit.year)) {
          classes.push(Namespace.css.active);
        }

        if (!_this9.validation.isValid(innerDate, Unit.year)) {
          classes.push(Namespace.css.disabled);
        }

        paint(Unit.year, innerDate, classes, containerClone);

        (_containerClone$class3 = containerClone.classList).remove.apply(_containerClone$class3, _toConsumableArray(containerClone.classList));

        (_containerClone$class4 = containerClone.classList).add.apply(_containerClone$class4, classes);

        containerClone.setAttribute('data-value', "".concat(innerDate.year));
        containerClone.innerText = innerDate.format({
          year: 'numeric'
        });
        innerDate.manipulate(1, Unit.year);
      });
    }
  }]);

  return YearDisplay;
}();
/**
 * Creates and updates the grid for `seconds`
 */


var DecadeDisplay = /*#__PURE__*/function () {
  function DecadeDisplay() {
    _classCallCheck(this, DecadeDisplay);

    this.optionsStore = serviceLocator.locate(OptionsStore);
    this.dates = serviceLocator.locate(Dates);
    this.validation = serviceLocator.locate(Validation);
  }
  /**
   * Build the container html for the display
   * @private
   */


  _createClass(DecadeDisplay, [{
    key: "getPicker",
    value: function getPicker() {
      var container = document.createElement('div');
      container.classList.add(Namespace.css.decadesContainer);

      for (var i = 0; i < 12; i++) {
        var div = document.createElement('div');
        div.setAttribute('data-action', ActionTypes$1.selectDecade);
        container.appendChild(div);
      }

      return container;
    }
    /**
     * Populates the grid and updates enabled states
     * @private
     */

  }, {
    key: "_update",
    value: function _update(widget, paint) {
      var _this10 = this;

      var _Dates$getStartEndYea = Dates.getStartEndYear(100, this.optionsStore.viewDate.year),
          _Dates$getStartEndYea2 = _slicedToArray(_Dates$getStartEndYea, 2),
          start = _Dates$getStartEndYea2[0],
          end = _Dates$getStartEndYea2[1];

      this._startDecade = this.optionsStore.viewDate.clone.startOf(Unit.year);
      this._startDecade.year = start;
      this._endDecade = this.optionsStore.viewDate.clone.startOf(Unit.year);
      this._endDecade.year = end;
      var container = widget.getElementsByClassName(Namespace.css.decadesContainer)[0];

      var _container$parentElem7 = container.parentElement.getElementsByClassName(Namespace.css.calendarHeader)[0].getElementsByTagName('div'),
          _container$parentElem8 = _slicedToArray(_container$parentElem7, 3),
          previous = _container$parentElem8[0],
          switcher = _container$parentElem8[1],
          next = _container$parentElem8[2];

      if (this.optionsStore.currentView === 'decades') {
        switcher.setAttribute(Namespace.css.decadesContainer, "".concat(this._startDecade.format({
          year: 'numeric'
        }), "-").concat(this._endDecade.format({
          year: 'numeric'
        })));
        this.validation.isValid(this._startDecade, Unit.year) ? previous.classList.remove(Namespace.css.disabled) : previous.classList.add(Namespace.css.disabled);
        this.validation.isValid(this._endDecade, Unit.year) ? next.classList.remove(Namespace.css.disabled) : next.classList.add(Namespace.css.disabled);
      }

      var pickedYears = this.dates.picked.map(function (x) {
        return x.year;
      });
      container.querySelectorAll("[data-action=\"".concat(ActionTypes$1.selectDecade, "\"]")).forEach(function (containerClone, index) {
        var _containerClone$class5, _containerClone$class6;

        if (index === 0) {
          containerClone.classList.add(Namespace.css.old);

          if (_this10._startDecade.year - 10 < 0) {
            containerClone.textContent = ' ';
            previous.classList.add(Namespace.css.disabled);
            containerClone.classList.add(Namespace.css.disabled);
            containerClone.setAttribute('data-value', '');
            return;
          } else {
            containerClone.innerText = _this10._startDecade.clone.manipulate(-10, Unit.year).format({
              year: 'numeric'
            });
            containerClone.setAttribute('data-value', "".concat(_this10._startDecade.year));
            return;
          }
        }

        var classes = [];
        classes.push(Namespace.css.decade);
        var startDecadeYear = _this10._startDecade.year;
        var endDecadeYear = _this10._startDecade.year + 9;

        if (!_this10.optionsStore.unset && pickedYears.filter(function (x) {
          return x >= startDecadeYear && x <= endDecadeYear;
        }).length > 0) {
          classes.push(Namespace.css.active);
        }

        if (!_this10.validation.isValid(_this10._startDecade, Unit.year) && !_this10.validation.isValid(_this10._startDecade.clone.manipulate(10, Unit.year), Unit.year)) {
          classes.push(Namespace.css.disabled);
        }

        paint('decade', _this10._startDecade, classes, containerClone);

        (_containerClone$class5 = containerClone.classList).remove.apply(_containerClone$class5, _toConsumableArray(containerClone.classList));

        (_containerClone$class6 = containerClone.classList).add.apply(_containerClone$class6, classes);

        containerClone.setAttribute('data-value', "".concat(_this10._startDecade.year));
        containerClone.innerText = "".concat(_this10._startDecade.format({
          year: 'numeric'
        }));

        _this10._startDecade.manipulate(10, Unit.year);
      });
    }
  }]);

  return DecadeDisplay;
}();
/**
 * Creates the clock display
 */


var TimeDisplay = /*#__PURE__*/function () {
  function TimeDisplay() {
    _classCallCheck(this, TimeDisplay);

    this._gridColumns = '';
    this.optionsStore = serviceLocator.locate(OptionsStore);
    this.dates = serviceLocator.locate(Dates);
    this.validation = serviceLocator.locate(Validation);
  }
  /**
   * Build the container html for the clock display
   * @private
   */


  _createClass(TimeDisplay, [{
    key: "getPicker",
    value: function getPicker(iconTag) {
      var container = document.createElement('div');
      container.classList.add(Namespace.css.clockContainer);
      container.append.apply(container, _toConsumableArray(this._grid(iconTag)));
      return container;
    }
    /**
     * Populates the various elements with in the clock display
     * like the current hour and if the manipulation icons are enabled.
     * @private
     */

  }, {
    key: "_update",
    value: function _update(widget) {
      var _this$dates$lastPicke;

      var timesDiv = widget.getElementsByClassName(Namespace.css.clockContainer)[0];
      var lastPicked = (_this$dates$lastPicke = this.dates.lastPicked) === null || _this$dates$lastPicke === void 0 ? void 0 : _this$dates$lastPicke.clone;
      if (!lastPicked && this.optionsStore.options.useCurrent) lastPicked = this.optionsStore.viewDate.clone;
      timesDiv.querySelectorAll('.disabled').forEach(function (element) {
        return element.classList.remove(Namespace.css.disabled);
      });

      if (this.optionsStore.options.display.components.hours) {
        if (!this.validation.isValid(this.optionsStore.viewDate.clone.manipulate(1, Unit.hours), Unit.hours)) {
          timesDiv.querySelector("[data-action=".concat(ActionTypes$1.incrementHours, "]")).classList.add(Namespace.css.disabled);
        }

        if (!this.validation.isValid(this.optionsStore.viewDate.clone.manipulate(-1, Unit.hours), Unit.hours)) {
          timesDiv.querySelector("[data-action=".concat(ActionTypes$1.decrementHours, "]")).classList.add(Namespace.css.disabled);
        }

        timesDiv.querySelector("[data-time-component=".concat(Unit.hours, "]")).innerText = lastPicked ? lastPicked.getHoursFormatted(this.optionsStore.options.localization.hourCycle) : '--';
      }

      if (this.optionsStore.options.display.components.minutes) {
        if (!this.validation.isValid(this.optionsStore.viewDate.clone.manipulate(1, Unit.minutes), Unit.minutes)) {
          timesDiv.querySelector("[data-action=".concat(ActionTypes$1.incrementMinutes, "]")).classList.add(Namespace.css.disabled);
        }

        if (!this.validation.isValid(this.optionsStore.viewDate.clone.manipulate(-1, Unit.minutes), Unit.minutes)) {
          timesDiv.querySelector("[data-action=".concat(ActionTypes$1.decrementMinutes, "]")).classList.add(Namespace.css.disabled);
        }

        timesDiv.querySelector("[data-time-component=".concat(Unit.minutes, "]")).innerText = lastPicked ? lastPicked.minutesFormatted : '--';
      }

      if (this.optionsStore.options.display.components.seconds) {
        if (!this.validation.isValid(this.optionsStore.viewDate.clone.manipulate(1, Unit.seconds), Unit.seconds)) {
          timesDiv.querySelector("[data-action=".concat(ActionTypes$1.incrementSeconds, "]")).classList.add(Namespace.css.disabled);
        }

        if (!this.validation.isValid(this.optionsStore.viewDate.clone.manipulate(-1, Unit.seconds), Unit.seconds)) {
          timesDiv.querySelector("[data-action=".concat(ActionTypes$1.decrementSeconds, "]")).classList.add(Namespace.css.disabled);
        }

        timesDiv.querySelector("[data-time-component=".concat(Unit.seconds, "]")).innerText = lastPicked ? lastPicked.secondsFormatted : '--';
      }

      if (this.optionsStore.isTwelveHour) {
        var toggle = timesDiv.querySelector("[data-action=".concat(ActionTypes$1.toggleMeridiem, "]"));
        var meridiemDate = (lastPicked || this.optionsStore.viewDate).clone;
        toggle.innerText = meridiemDate.meridiem();

        if (!this.validation.isValid(meridiemDate.manipulate(meridiemDate.hours >= 12 ? -12 : 12, Unit.hours))) {
          toggle.classList.add(Namespace.css.disabled);
        } else {
          toggle.classList.remove(Namespace.css.disabled);
        }
      }

      timesDiv.style.gridTemplateAreas = "\"".concat(this._gridColumns, "\"");
    }
    /**
     * Creates the table for the clock display depending on what options are selected.
     * @private
     */

  }, {
    key: "_grid",
    value: function _grid(iconTag) {
      this._gridColumns = '';
      var top = [],
          middle = [],
          bottom = [],
          separator = document.createElement('div'),
          upIcon = iconTag(this.optionsStore.options.display.icons.up),
          downIcon = iconTag(this.optionsStore.options.display.icons.down);
      separator.classList.add(Namespace.css.separator, Namespace.css.noHighlight);
      var separatorColon = separator.cloneNode(true);
      separatorColon.innerHTML = ':';

      var getSeparator = function getSeparator() {
        var colon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return colon ? separatorColon.cloneNode(true) : separator.cloneNode(true);
      };

      if (this.optionsStore.options.display.components.hours) {
        var divElement = document.createElement('div');
        divElement.setAttribute('title', this.optionsStore.options.localization.incrementHour);
        divElement.setAttribute('data-action', ActionTypes$1.incrementHours);
        divElement.appendChild(upIcon.cloneNode(true));
        top.push(divElement);
        divElement = document.createElement('div');
        divElement.setAttribute('title', this.optionsStore.options.localization.pickHour);
        divElement.setAttribute('data-action', ActionTypes$1.showHours);
        divElement.setAttribute('data-time-component', Unit.hours);
        middle.push(divElement);
        divElement = document.createElement('div');
        divElement.setAttribute('title', this.optionsStore.options.localization.decrementHour);
        divElement.setAttribute('data-action', ActionTypes$1.decrementHours);
        divElement.appendChild(downIcon.cloneNode(true));
        bottom.push(divElement);
        this._gridColumns += 'a';
      }

      if (this.optionsStore.options.display.components.minutes) {
        this._gridColumns += ' a';

        if (this.optionsStore.options.display.components.hours) {
          top.push(getSeparator());
          middle.push(getSeparator(true));
          bottom.push(getSeparator());
          this._gridColumns += ' a';
        }

        var _divElement = document.createElement('div');

        _divElement.setAttribute('title', this.optionsStore.options.localization.incrementMinute);

        _divElement.setAttribute('data-action', ActionTypes$1.incrementMinutes);

        _divElement.appendChild(upIcon.cloneNode(true));

        top.push(_divElement);
        _divElement = document.createElement('div');

        _divElement.setAttribute('title', this.optionsStore.options.localization.pickMinute);

        _divElement.setAttribute('data-action', ActionTypes$1.showMinutes);

        _divElement.setAttribute('data-time-component', Unit.minutes);

        middle.push(_divElement);
        _divElement = document.createElement('div');

        _divElement.setAttribute('title', this.optionsStore.options.localization.decrementMinute);

        _divElement.setAttribute('data-action', ActionTypes$1.decrementMinutes);

        _divElement.appendChild(downIcon.cloneNode(true));

        bottom.push(_divElement);
      }

      if (this.optionsStore.options.display.components.seconds) {
        this._gridColumns += ' a';

        if (this.optionsStore.options.display.components.minutes) {
          top.push(getSeparator());
          middle.push(getSeparator(true));
          bottom.push(getSeparator());
          this._gridColumns += ' a';
        }

        var _divElement2 = document.createElement('div');

        _divElement2.setAttribute('title', this.optionsStore.options.localization.incrementSecond);

        _divElement2.setAttribute('data-action', ActionTypes$1.incrementSeconds);

        _divElement2.appendChild(upIcon.cloneNode(true));

        top.push(_divElement2);
        _divElement2 = document.createElement('div');

        _divElement2.setAttribute('title', this.optionsStore.options.localization.pickSecond);

        _divElement2.setAttribute('data-action', ActionTypes$1.showSeconds);

        _divElement2.setAttribute('data-time-component', Unit.seconds);

        middle.push(_divElement2);
        _divElement2 = document.createElement('div');

        _divElement2.setAttribute('title', this.optionsStore.options.localization.decrementSecond);

        _divElement2.setAttribute('data-action', ActionTypes$1.decrementSeconds);

        _divElement2.appendChild(downIcon.cloneNode(true));

        bottom.push(_divElement2);
      }

      if (this.optionsStore.isTwelveHour) {
        this._gridColumns += ' a';

        var _divElement3 = getSeparator();

        top.push(_divElement3);
        var button = document.createElement('button');
        button.setAttribute('type', 'button');
        button.setAttribute('title', this.optionsStore.options.localization.toggleMeridiem);
        button.setAttribute('data-action', ActionTypes$1.toggleMeridiem);
        button.setAttribute('tabindex', '-1');

        if (Namespace.css.toggleMeridiem.includes(',')) {
          var _button$classList;

          //todo move this to paint function?
          (_button$classList = button.classList).add.apply(_button$classList, _toConsumableArray(Namespace.css.toggleMeridiem.split(',')));
        } else button.classList.add(Namespace.css.toggleMeridiem);

        _divElement3 = document.createElement('div');

        _divElement3.classList.add(Namespace.css.noHighlight);

        _divElement3.appendChild(button);

        middle.push(_divElement3);
        _divElement3 = getSeparator();
        bottom.push(_divElement3);
      }

      this._gridColumns = this._gridColumns.trim();
      return [].concat(top, middle, bottom);
    }
  }]);

  return TimeDisplay;
}();
/**
 * Creates and updates the grid for `hours`
 */


var HourDisplay = /*#__PURE__*/function () {
  function HourDisplay() {
    _classCallCheck(this, HourDisplay);

    this.optionsStore = serviceLocator.locate(OptionsStore);
    this.validation = serviceLocator.locate(Validation);
  }
  /**
   * Build the container html for the display
   * @private
   */


  _createClass(HourDisplay, [{
    key: "getPicker",
    value: function getPicker() {
      var container = document.createElement('div');
      container.classList.add(Namespace.css.hourContainer);

      for (var i = 0; i < (this.optionsStore.isTwelveHour ? 12 : 24); i++) {
        var div = document.createElement('div');
        div.setAttribute('data-action', ActionTypes$1.selectHour);
        container.appendChild(div);
      }

      return container;
    }
    /**
     * Populates the grid and updates enabled states
     * @private
     */

  }, {
    key: "_update",
    value: function _update(widget, paint) {
      var _this11 = this;

      var container = widget.getElementsByClassName(Namespace.css.hourContainer)[0];
      var innerDate = this.optionsStore.viewDate.clone.startOf(Unit.date);
      container.querySelectorAll("[data-action=\"".concat(ActionTypes$1.selectHour, "\"]")).forEach(function (containerClone) {
        var _containerClone$class7, _containerClone$class8;

        var classes = [];
        classes.push(Namespace.css.hour);

        if (!_this11.validation.isValid(innerDate, Unit.hours)) {
          classes.push(Namespace.css.disabled);
        }

        paint(Unit.hours, innerDate, classes, containerClone);

        (_containerClone$class7 = containerClone.classList).remove.apply(_containerClone$class7, _toConsumableArray(containerClone.classList));

        (_containerClone$class8 = containerClone.classList).add.apply(_containerClone$class8, classes);

        containerClone.setAttribute('data-value', "".concat(innerDate.hours));
        containerClone.innerText = innerDate.getHoursFormatted(_this11.optionsStore.options.localization.hourCycle);
        innerDate.manipulate(1, Unit.hours);
      });
    }
  }]);

  return HourDisplay;
}();
/**
 * Creates and updates the grid for `minutes`
 */


var MinuteDisplay = /*#__PURE__*/function () {
  function MinuteDisplay() {
    _classCallCheck(this, MinuteDisplay);

    this.optionsStore = serviceLocator.locate(OptionsStore);
    this.validation = serviceLocator.locate(Validation);
  }
  /**
   * Build the container html for the display
   * @private
   */


  _createClass(MinuteDisplay, [{
    key: "getPicker",
    value: function getPicker() {
      var container = document.createElement('div');
      container.classList.add(Namespace.css.minuteContainer);
      var step = this.optionsStore.options.stepping === 1 ? 5 : this.optionsStore.options.stepping;

      for (var i = 0; i < 60 / step; i++) {
        var div = document.createElement('div');
        div.setAttribute('data-action', ActionTypes$1.selectMinute);
        container.appendChild(div);
      }

      return container;
    }
    /**
     * Populates the grid and updates enabled states
     * @private
     */

  }, {
    key: "_update",
    value: function _update(widget, paint) {
      var _this12 = this;

      var container = widget.getElementsByClassName(Namespace.css.minuteContainer)[0];
      var innerDate = this.optionsStore.viewDate.clone.startOf(Unit.hours);
      var step = this.optionsStore.options.stepping === 1 ? 5 : this.optionsStore.options.stepping;
      container.querySelectorAll("[data-action=\"".concat(ActionTypes$1.selectMinute, "\"]")).forEach(function (containerClone) {
        var _containerClone$class9, _containerClone$class10;

        var classes = [];
        classes.push(Namespace.css.minute);

        if (!_this12.validation.isValid(innerDate, Unit.minutes)) {
          classes.push(Namespace.css.disabled);
        }

        paint(Unit.minutes, innerDate, classes, containerClone);

        (_containerClone$class9 = containerClone.classList).remove.apply(_containerClone$class9, _toConsumableArray(containerClone.classList));

        (_containerClone$class10 = containerClone.classList).add.apply(_containerClone$class10, classes);

        containerClone.setAttribute('data-value', "".concat(innerDate.minutes));
        containerClone.innerText = innerDate.minutesFormatted;
        innerDate.manipulate(step, Unit.minutes);
      });
    }
  }]);

  return MinuteDisplay;
}();
/**
 * Creates and updates the grid for `seconds`
 */


var secondDisplay = /*#__PURE__*/function () {
  function secondDisplay() {
    _classCallCheck(this, secondDisplay);

    this.optionsStore = serviceLocator.locate(OptionsStore);
    this.validation = serviceLocator.locate(Validation);
  }
  /**
   * Build the container html for the display
   * @private
   */


  _createClass(secondDisplay, [{
    key: "getPicker",
    value: function getPicker() {
      var container = document.createElement('div');
      container.classList.add(Namespace.css.secondContainer);

      for (var i = 0; i < 12; i++) {
        var div = document.createElement('div');
        div.setAttribute('data-action', ActionTypes$1.selectSecond);
        container.appendChild(div);
      }

      return container;
    }
    /**
     * Populates the grid and updates enabled states
     * @private
     */

  }, {
    key: "_update",
    value: function _update(widget, paint) {
      var _this13 = this;

      var container = widget.getElementsByClassName(Namespace.css.secondContainer)[0];
      var innerDate = this.optionsStore.viewDate.clone.startOf(Unit.minutes);
      container.querySelectorAll("[data-action=\"".concat(ActionTypes$1.selectSecond, "\"]")).forEach(function (containerClone) {
        var _containerClone$class11, _containerClone$class12;

        var classes = [];
        classes.push(Namespace.css.second);

        if (!_this13.validation.isValid(innerDate, Unit.seconds)) {
          classes.push(Namespace.css.disabled);
        }

        paint(Unit.seconds, innerDate, classes, containerClone);

        (_containerClone$class11 = containerClone.classList).remove.apply(_containerClone$class11, _toConsumableArray(containerClone.classList));

        (_containerClone$class12 = containerClone.classList).add.apply(_containerClone$class12, classes);

        containerClone.setAttribute('data-value', "".concat(innerDate.seconds));
        containerClone.innerText = innerDate.secondsFormatted;
        innerDate.manipulate(5, Unit.seconds);
      });
    }
  }]);

  return secondDisplay;
}();
/**
 * Provides a collapse functionality to the view changes
 */


var Collapse = /*#__PURE__*/function () {
  function Collapse() {
    _classCallCheck(this, Collapse);
  }

  _createClass(Collapse, null, [{
    key: "toggle",

    /**
     * Flips the show/hide state of `target`
     * @param target html element to affect.
     */
    value: function toggle(target) {
      if (target.classList.contains(Namespace.css.show)) {
        this.hide(target);
      } else {
        this.show(target);
      }
    }
    /**
     * Skips any animation or timeouts and immediately set the element to show.
     * @param target
     */

  }, {
    key: "showImmediately",
    value: function showImmediately(target) {
      target.classList.remove(Namespace.css.collapsing);
      target.classList.add(Namespace.css.collapse, Namespace.css.show);
      target.style.height = '';
    }
    /**
     * If `target` is not already showing, then show after the animation.
     * @param target
     */

  }, {
    key: "show",
    value: function show(target) {
      if (target.classList.contains(Namespace.css.collapsing) || target.classList.contains(Namespace.css.show)) return;

      var complete = function complete() {
        Collapse.showImmediately(target);
      };

      target.style.height = '0';
      target.classList.remove(Namespace.css.collapse);
      target.classList.add(Namespace.css.collapsing); //eslint-disable-next-line @typescript-eslint/no-unused-vars

      setTimeout(complete, this.getTransitionDurationFromElement(target));
      target.style.height = "".concat(target.scrollHeight, "px");
    }
    /**
     * Skips any animation or timeouts and immediately set the element to hide.
     * @param target
     */

  }, {
    key: "hideImmediately",
    value: function hideImmediately(target) {
      if (!target) return;
      target.classList.remove(Namespace.css.collapsing, Namespace.css.show);
      target.classList.add(Namespace.css.collapse);
    }
    /**
     * If `target` is not already hidden, then hide after the animation.
     * @param target HTML Element
     */

  }, {
    key: "hide",
    value: function hide(target) {
      if (target.classList.contains(Namespace.css.collapsing) || !target.classList.contains(Namespace.css.show)) return;

      var complete = function complete() {
        Collapse.hideImmediately(target);
      };

      target.style.height = "".concat(target.getBoundingClientRect()['height'], "px");

      var reflow = function reflow(element) {
        return element.offsetHeight;
      };

      reflow(target);
      target.classList.remove(Namespace.css.collapse, Namespace.css.show);
      target.classList.add(Namespace.css.collapsing);
      target.style.height = ''; //eslint-disable-next-line @typescript-eslint/no-unused-vars

      setTimeout(complete, this.getTransitionDurationFromElement(target));
    }
  }]);

  return Collapse;
}();
/**
 * Gets the transition duration from the `element` by getting css properties
 * `transition-duration` and `transition-delay`
 * @param element HTML Element
 */


Collapse.getTransitionDurationFromElement = function (element) {
  if (!element) {
    return 0;
  } // Get transition-duration of the element


  var _window$getComputedSt = window.getComputedStyle(element),
      transitionDuration = _window$getComputedSt.transitionDuration,
      transitionDelay = _window$getComputedSt.transitionDelay;

  var floatTransitionDuration = Number.parseFloat(transitionDuration);
  var floatTransitionDelay = Number.parseFloat(transitionDelay); // Return 0 if element or transition duration is not found

  if (!floatTransitionDuration && !floatTransitionDelay) {
    return 0;
  } // If multiple durations are defined, take the first


  transitionDuration = transitionDuration.split(',')[0];
  transitionDelay = transitionDelay.split(',')[0];
  return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * 1000;
};
/**
 * Main class for all things display related.
 */


var Display = /*#__PURE__*/function () {
  function Display() {
    var _this14 = this;

    _classCallCheck(this, Display);

    this._isVisible = false;
    /**
     * A document click event to hide the widget if click is outside
     * @private
     * @param e MouseEvent
     */

    this._documentClickEvent = function (e) {
      var _e$composedPath;

      if (_this14.optionsStore.options.debug || window.debug) return; //eslint-disable-line @typescript-eslint/no-explicit-any

      if (_this14._isVisible && !e.composedPath().includes(_this14.widget) && // click inside the widget
      !((_e$composedPath = e.composedPath()) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath.includes(_this14.optionsStore.element)) // click on the element
      ) {
          _this14.hide();
        }
    };
    /**
     * Click event for any action like selecting a date
     * @param e MouseEvent
     * @private
     */


    this._actionsClickEvent = function (e) {
      _this14._eventEmitters.action.emit({
        e: e
      });
    };

    this.optionsStore = serviceLocator.locate(OptionsStore);
    this.validation = serviceLocator.locate(Validation);
    this.dates = serviceLocator.locate(Dates);
    this.dateDisplay = serviceLocator.locate(DateDisplay);
    this.monthDisplay = serviceLocator.locate(MonthDisplay);
    this.yearDisplay = serviceLocator.locate(YearDisplay);
    this.decadeDisplay = serviceLocator.locate(DecadeDisplay);
    this.timeDisplay = serviceLocator.locate(TimeDisplay);
    this.hourDisplay = serviceLocator.locate(HourDisplay);
    this.minuteDisplay = serviceLocator.locate(MinuteDisplay);
    this.secondDisplay = serviceLocator.locate(secondDisplay);
    this._eventEmitters = serviceLocator.locate(EventEmitters);
    this._widget = undefined;

    this._eventEmitters.updateDisplay.subscribe(function (result) {
      _this14._update(result);
    });
  }
  /**
   * Returns the widget body or undefined
   * @private
   */


  _createClass(Display, [{
    key: "_update",

    /**
     * Updates the table for a particular unit. Used when an option as changed or
     * whenever the class list might need to be refreshed.
     * @param unit
     * @private
     */
    value: function _update(unit) {
      if (!this.widget) return;

      switch (unit) {
        case Unit.seconds:
          this.secondDisplay._update(this.widget, this.paint);

          break;

        case Unit.minutes:
          this.minuteDisplay._update(this.widget, this.paint);

          break;

        case Unit.hours:
          this.hourDisplay._update(this.widget, this.paint);

          break;

        case Unit.date:
          this.dateDisplay._update(this.widget, this.paint);

          break;

        case Unit.month:
          this.monthDisplay._update(this.widget, this.paint);

          break;

        case Unit.year:
          this.yearDisplay._update(this.widget, this.paint);

          break;

        case 'decade':
          this.decadeDisplay._update(this.widget, this.paint);

          break;

        case 'clock':
          if (!this._hasTime) break;

          this.timeDisplay._update(this.widget);

          this._update(Unit.hours);

          this._update(Unit.minutes);

          this._update(Unit.seconds);

          break;

        case 'calendar':
          this._update(Unit.date);

          this._update(Unit.year);

          this._update(Unit.month);

          this.decadeDisplay._update(this.widget, this.paint);

          this._updateCalendarHeader();

          break;

        case 'all':
          if (this._hasTime) {
            this._update('clock');
          }

          if (this._hasDate) {
            this._update('calendar');
          }

      }
    } // noinspection JSUnusedLocalSymbols

    /**
     * Allows developers to add/remove classes from an element.
     * @param _unit
     * @param _date
     * @param _classes
     * @param _element
     */

    /* eslint-disable @typescript-eslint/no-unused-vars */

  }, {
    key: "paint",
    value: function paint(_unit, _date, _classes, _element) {} // implemented in plugin

    /**
     * Shows the picker and creates a Popper instance if needed.
     * Add document click event to hide when clicking outside the picker.
     * fires Events#show
     */

  }, {
    key: "show",
    value: function show() {
      var _this15 = this;

      if (this.widget == undefined) {
        this._showSetDefaultIfNeeded();

        this._buildWidget();

        this._updateTheme();

        this._showSetupViewMode();

        if (!this.optionsStore.options.display.inline) {
          var _this$optionsStore$op3, _this$optionsStore$op4, _this$optionsStore$op5;

          // If needed to change the parent container
          var container = ((_this$optionsStore$op3 = this.optionsStore.options) === null || _this$optionsStore$op3 === void 0 ? void 0 : _this$optionsStore$op3.container) || document.body;
          var placement = ((_this$optionsStore$op4 = this.optionsStore.options) === null || _this$optionsStore$op4 === void 0 ? void 0 : (_this$optionsStore$op5 = _this$optionsStore$op4.display) === null || _this$optionsStore$op5 === void 0 ? void 0 : _this$optionsStore$op5.placement) || 'bottom';
          container.appendChild(this.widget);
          this.createPopup(this.optionsStore.element, this.widget, {
            modifiers: [{
              name: 'eventListeners',
              enabled: true
            }],
            //#2400
            placement: document.documentElement.dir === 'rtl' ? "".concat(placement, "-end") : "".concat(placement, "-start")
          }).then();
        } else {
          this.optionsStore.element.appendChild(this.widget);
        }

        if (this.optionsStore.options.display.viewMode == 'clock') {
          this._eventEmitters.action.emit({
            e: null,
            action: ActionTypes$1.showClock
          });
        }

        this.widget.querySelectorAll('[data-action]').forEach(function (element) {
          return element.addEventListener('click', _this15._actionsClickEvent);
        }); // show the clock when using sideBySide

        if (this._hasTime && this.optionsStore.options.display.sideBySide) {
          this.timeDisplay._update(this.widget);

          this.widget.getElementsByClassName(Namespace.css.clockContainer)[0].style.display = 'grid';
        }
      }

      this.widget.classList.add(Namespace.css.show);

      if (!this.optionsStore.options.display.inline) {
        this.updatePopup();
        document.addEventListener('click', this._documentClickEvent);
      }

      this._eventEmitters.triggerEvent.emit({
        type: Namespace.events.show
      });

      this._isVisible = true;
    }
  }, {
    key: "_showSetupViewMode",
    value: function _showSetupViewMode() {
      // If modeView is only clock
      var onlyClock = this._hasTime && !this._hasDate; // reset the view to the clock if there's no date components

      if (onlyClock) {
        this.optionsStore.currentView = 'clock';

        this._eventEmitters.action.emit({
          e: null,
          action: ActionTypes$1.showClock
        });
      } // otherwise return to the calendar view
      else if (!this.optionsStore.currentCalendarViewMode) {
          this.optionsStore.currentCalendarViewMode = this.optionsStore.minimumCalendarViewMode;
        }

      if (!onlyClock && this.optionsStore.options.display.viewMode !== 'clock') {
        if (this._hasTime) {
          if (!this.optionsStore.options.display.sideBySide) {
            Collapse.hideImmediately(this.timeContainer);
          } else {
            Collapse.show(this.timeContainer);
          }
        }

        Collapse.show(this.dateContainer);
      }

      if (this._hasDate) {
        this._showMode();
      }
    }
  }, {
    key: "_showSetDefaultIfNeeded",
    value: function _showSetDefaultIfNeeded() {
      if (this.dates.picked.length != 0) return;

      if (this.optionsStore.options.useCurrent && !this.optionsStore.options.defaultDate) {
        var date = new DateTime().setLocalization(this.optionsStore.options.localization);

        if (!this.optionsStore.options.keepInvalid) {
          var _this$optionsStore$op6;

          var tries = 0;
          var direction = 1;

          if ((_this$optionsStore$op6 = this.optionsStore.options.restrictions.maxDate) === null || _this$optionsStore$op6 === void 0 ? void 0 : _this$optionsStore$op6.isBefore(date)) {
            direction = -1;
          }

          while (!this.validation.isValid(date) && tries > 31) {
            date.manipulate(direction, Unit.date);
            tries++;
          }
        }

        this.dates.setValue(date);
      }

      if (this.optionsStore.options.defaultDate) {
        this.dates.setValue(this.optionsStore.options.defaultDate);
      }
    }
  }, {
    key: "createPopup",
    value: function () {
      var _createPopup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(element, widget, //eslint-disable-next-line @typescript-eslint/no-explicit-any
      options) {
        var _window;

        var createPopperFunction, _window2, _window2$Popper, _yield$import, createPopper;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!((_window = window) === null || _window === void 0 ? void 0 : _window.Popper)) {
                  _context.next = 4;
                  break;
                }

                //eslint-disable-next-line @typescript-eslint/no-explicit-any
                createPopperFunction = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$Popper = _window2.Popper) === null || _window2$Popper === void 0 ? void 0 : _window2$Popper.createPopper;
                _context.next = 9;
                break;

              case 4:
                _context.next = 6;
                return import('@popperjs/core');

              case 6:
                _yield$import = _context.sent;
                createPopper = _yield$import.createPopper;
                createPopperFunction = createPopper;

              case 9:
                if (createPopperFunction) {
                  this._popperInstance = createPopperFunction(element, widget, options);
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createPopup(_x, _x2, _x3) {
        return _createPopup.apply(this, arguments);
      }

      return createPopup;
    }()
  }, {
    key: "updatePopup",
    value: function updatePopup() {
      var _this$_popperInstance;

      (_this$_popperInstance = this._popperInstance) === null || _this$_popperInstance === void 0 ? void 0 : _this$_popperInstance.update();
    }
    /**
     * Changes the calendar view mode. E.g. month <-> year
     * @param direction -/+ number to move currentViewMode
     * @private
     */

  }, {
    key: "_showMode",
    value: function _showMode(direction) {
      if (!this.widget) {
        return;
      }

      if (direction) {
        var max = Math.max(this.optionsStore.minimumCalendarViewMode, Math.min(3, this.optionsStore.currentCalendarViewMode + direction));
        if (this.optionsStore.currentCalendarViewMode == max) return;
        this.optionsStore.currentCalendarViewMode = max;
      }

      this.widget.querySelectorAll(".".concat(Namespace.css.dateContainer, " > div:not(.").concat(Namespace.css.calendarHeader, "), .").concat(Namespace.css.timeContainer, " > div:not(.").concat(Namespace.css.clockContainer, ")")).forEach(function (e) {
        return e.style.display = 'none';
      });
      var datePickerMode = CalendarModes[this.optionsStore.currentCalendarViewMode];
      var picker = this.widget.querySelector(".".concat(datePickerMode.className));

      switch (datePickerMode.className) {
        case Namespace.css.decadesContainer:
          this.decadeDisplay._update(this.widget, this.paint);

          break;

        case Namespace.css.yearsContainer:
          this.yearDisplay._update(this.widget, this.paint);

          break;

        case Namespace.css.monthsContainer:
          this.monthDisplay._update(this.widget, this.paint);

          break;

        case Namespace.css.daysContainer:
          this.dateDisplay._update(this.widget, this.paint);

          break;
      }

      picker.style.display = 'grid';
      if (this.optionsStore.options.display.sideBySide) this.widget.querySelectorAll(".".concat(Namespace.css.clockContainer))[0].style.display = 'grid';

      this._updateCalendarHeader();

      this._eventEmitters.viewUpdate.emit();
    }
    /**
     * Changes the theme. E.g. light, dark or auto
     * @param theme the theme name
     * @private
     */

  }, {
    key: "_updateTheme",
    value: function _updateTheme(theme) {
      var _this16 = this;

      if (!this.widget) {
        return;
      }

      if (theme) {
        if (this.optionsStore.options.display.theme === theme) return;
        this.optionsStore.options.display.theme = theme;
      }

      this.widget.classList.remove('light', 'dark');
      this.widget.classList.add(this._getThemeClass());

      if (this.optionsStore.options.display.theme === 'auto') {
        window.matchMedia(Namespace.css.isDarkPreferredQuery).addEventListener('change', function () {
          return _this16._updateTheme();
        });
      } else {
        window.matchMedia(Namespace.css.isDarkPreferredQuery).removeEventListener('change', function () {
          return _this16._updateTheme();
        });
      }
    }
  }, {
    key: "_getThemeClass",
    value: function _getThemeClass() {
      var currentTheme = this.optionsStore.options.display.theme || 'auto';
      var isDarkMode = window.matchMedia && window.matchMedia(Namespace.css.isDarkPreferredQuery).matches;

      switch (currentTheme) {
        case 'light':
          return Namespace.css.lightTheme;

        case 'dark':
          return Namespace.css.darkTheme;

        case 'auto':
          return isDarkMode ? Namespace.css.darkTheme : Namespace.css.lightTheme;
      }
    }
  }, {
    key: "_updateCalendarHeader",
    value: function _updateCalendarHeader() {
      if (!this._hasDate) return;

      var showing = _toConsumableArray(this.widget.querySelector(".".concat(Namespace.css.dateContainer, " div[style*=\"display: grid\"]")).classList).find(function (x) {
        return x.startsWith(Namespace.css.dateContainer);
      });

      var _this$widget$getEleme = this.widget.getElementsByClassName(Namespace.css.calendarHeader)[0].getElementsByTagName('div'),
          _this$widget$getEleme2 = _slicedToArray(_this$widget$getEleme, 3),
          previous = _this$widget$getEleme2[0],
          switcher = _this$widget$getEleme2[1],
          next = _this$widget$getEleme2[2];

      switch (showing) {
        case Namespace.css.decadesContainer:
          previous.setAttribute('title', this.optionsStore.options.localization.previousCentury);
          switcher.setAttribute('title', '');
          next.setAttribute('title', this.optionsStore.options.localization.nextCentury);
          break;

        case Namespace.css.yearsContainer:
          previous.setAttribute('title', this.optionsStore.options.localization.previousDecade);
          switcher.setAttribute('title', this.optionsStore.options.localization.selectDecade);
          next.setAttribute('title', this.optionsStore.options.localization.nextDecade);
          break;

        case Namespace.css.monthsContainer:
          previous.setAttribute('title', this.optionsStore.options.localization.previousYear);
          switcher.setAttribute('title', this.optionsStore.options.localization.selectYear);
          next.setAttribute('title', this.optionsStore.options.localization.nextYear);
          break;

        case Namespace.css.daysContainer:
          previous.setAttribute('title', this.optionsStore.options.localization.previousMonth);
          switcher.setAttribute('title', this.optionsStore.options.localization.selectMonth);
          next.setAttribute('title', this.optionsStore.options.localization.nextMonth);
          switcher.setAttribute(showing, this.optionsStore.viewDate.format(this.optionsStore.options.localization.dayViewHeaderFormat));
          break;
      }

      switcher.innerText = switcher.getAttribute(showing);
    }
    /**
     * Hides the picker if needed.
     * Remove document click event to hide when clicking outside the picker.
     * fires Events#hide
     */

  }, {
    key: "hide",
    value: function hide() {
      if (!this.widget || !this._isVisible) return;
      this.widget.classList.remove(Namespace.css.show);

      if (this._isVisible) {
        var _this$dates$lastPicke2;

        this._eventEmitters.triggerEvent.emit({
          type: Namespace.events.hide,
          date: this.optionsStore.unset ? null : (_this$dates$lastPicke2 = this.dates.lastPicked) === null || _this$dates$lastPicke2 === void 0 ? void 0 : _this$dates$lastPicke2.clone
        });

        this._isVisible = false;
      }

      document.removeEventListener('click', this._documentClickEvent);
    }
    /**
     * Toggles the picker's open state. Fires a show/hide event depending.
     */

  }, {
    key: "toggle",
    value: function toggle() {
      return this._isVisible ? this.hide() : this.show();
    }
    /**
     * Removes document and data-action click listener and reset the widget
     * @private
     */

  }, {
    key: "_dispose",
    value: function _dispose() {
      var _this17 = this;

      document.removeEventListener('click', this._documentClickEvent);
      if (!this.widget) return;
      this.widget.querySelectorAll('[data-action]').forEach(function (element) {
        return element.removeEventListener('click', _this17._actionsClickEvent);
      });
      this.widget.parentNode.removeChild(this.widget);
      this._widget = undefined;
    }
    /**
     * Builds the widgets html template.
     * @private
     */

  }, {
    key: "_buildWidget",
    value: function _buildWidget() {
      var template = document.createElement('div');
      template.classList.add(Namespace.css.widget);
      var dateView = document.createElement('div');
      dateView.classList.add(Namespace.css.dateContainer);
      dateView.append(this.getHeadTemplate(), this.decadeDisplay.getPicker(), this.yearDisplay.getPicker(), this.monthDisplay.getPicker(), this.dateDisplay.getPicker());
      var timeView = document.createElement('div');
      timeView.classList.add(Namespace.css.timeContainer);
      timeView.appendChild(this.timeDisplay.getPicker(this._iconTag.bind(this)));
      timeView.appendChild(this.hourDisplay.getPicker());
      timeView.appendChild(this.minuteDisplay.getPicker());
      timeView.appendChild(this.secondDisplay.getPicker());
      var toolbar = document.createElement('div');
      toolbar.classList.add(Namespace.css.toolbar);
      toolbar.append.apply(toolbar, _toConsumableArray(this.getToolbarElements()));

      if (this.optionsStore.options.display.inline) {
        template.classList.add(Namespace.css.inline);
      }

      if (this.optionsStore.options.display.calendarWeeks) {
        template.classList.add('calendarWeeks');
      }

      if (this.optionsStore.options.display.sideBySide && this._hasDateAndTime) {
        this._buildWidgetSideBySide(template, dateView, timeView, toolbar);

        return;
      }

      if (this.optionsStore.options.display.toolbarPlacement === 'top') {
        template.appendChild(toolbar);
      }

      var setupComponentView = function setupComponentView(hasFirst, hasSecond, element, shouldShow) {
        if (!hasFirst) return;

        if (hasSecond) {
          element.classList.add(Namespace.css.collapse);
          if (shouldShow) element.classList.add(Namespace.css.show);
        }

        template.appendChild(element);
      };

      setupComponentView(this._hasDate, this._hasTime, dateView, this.optionsStore.options.display.viewMode !== 'clock');
      setupComponentView(this._hasTime, this._hasDate, timeView, this.optionsStore.options.display.viewMode === 'clock');

      if (this.optionsStore.options.display.toolbarPlacement === 'bottom') {
        template.appendChild(toolbar);
      }

      var arrow = document.createElement('div');
      arrow.classList.add('arrow');
      arrow.setAttribute('data-popper-arrow', '');
      template.appendChild(arrow);
      this._widget = template;
    }
  }, {
    key: "_buildWidgetSideBySide",
    value: function _buildWidgetSideBySide(template, dateView, timeView, toolbar) {
      template.classList.add(Namespace.css.sideBySide);

      if (this.optionsStore.options.display.toolbarPlacement === 'top') {
        template.appendChild(toolbar);
      }

      var row = document.createElement('div');
      row.classList.add('td-row');
      dateView.classList.add('td-half');
      timeView.classList.add('td-half');
      row.appendChild(dateView);
      row.appendChild(timeView);
      template.appendChild(row);

      if (this.optionsStore.options.display.toolbarPlacement === 'bottom') {
        template.appendChild(toolbar);
      }

      this._widget = template;
    }
    /**
     * Returns true if the hours, minutes, or seconds component is turned on
     */

  }, {
    key: "getToolbarElements",

    /**
     * Get the toolbar html based on options like buttons => today
     * @private
     */
    value: function getToolbarElements() {
      var toolbar = [];

      if (this.optionsStore.options.display.buttons.today) {
        var div = document.createElement('div');
        div.setAttribute('data-action', ActionTypes$1.today);
        div.setAttribute('title', this.optionsStore.options.localization.today);
        div.appendChild(this._iconTag(this.optionsStore.options.display.icons.today));
        toolbar.push(div);
      }

      if (!this.optionsStore.options.display.sideBySide && this._hasDate && this._hasTime) {
        var title, icon;

        if (this.optionsStore.options.display.viewMode === 'clock') {
          title = this.optionsStore.options.localization.selectDate;
          icon = this.optionsStore.options.display.icons.date;
        } else {
          title = this.optionsStore.options.localization.selectTime;
          icon = this.optionsStore.options.display.icons.time;
        }

        var _div3 = document.createElement('div');

        _div3.setAttribute('data-action', ActionTypes$1.togglePicker);

        _div3.setAttribute('title', title);

        _div3.appendChild(this._iconTag(icon));

        toolbar.push(_div3);
      }

      if (this.optionsStore.options.display.buttons.clear) {
        var _div4 = document.createElement('div');

        _div4.setAttribute('data-action', ActionTypes$1.clear);

        _div4.setAttribute('title', this.optionsStore.options.localization.clear);

        _div4.appendChild(this._iconTag(this.optionsStore.options.display.icons.clear));

        toolbar.push(_div4);
      }

      if (this.optionsStore.options.display.buttons.close) {
        var _div5 = document.createElement('div');

        _div5.setAttribute('data-action', ActionTypes$1.close);

        _div5.setAttribute('title', this.optionsStore.options.localization.close);

        _div5.appendChild(this._iconTag(this.optionsStore.options.display.icons.close));

        toolbar.push(_div5);
      }

      return toolbar;
    }
    /***
     * Builds the base header template with next and previous icons
     * @private
     */

  }, {
    key: "getHeadTemplate",
    value: function getHeadTemplate() {
      var calendarHeader = document.createElement('div');
      calendarHeader.classList.add(Namespace.css.calendarHeader);
      var previous = document.createElement('div');
      previous.classList.add(Namespace.css.previous);
      previous.setAttribute('data-action', ActionTypes$1.previous);
      previous.appendChild(this._iconTag(this.optionsStore.options.display.icons.previous));
      var switcher = document.createElement('div');
      switcher.classList.add(Namespace.css.switch);
      switcher.setAttribute('data-action', ActionTypes$1.changeCalendarView);
      var next = document.createElement('div');
      next.classList.add(Namespace.css.next);
      next.setAttribute('data-action', ActionTypes$1.next);
      next.appendChild(this._iconTag(this.optionsStore.options.display.icons.next));
      calendarHeader.append(previous, switcher, next);
      return calendarHeader;
    }
    /**
     * Builds an icon tag as either an `<i>`
     * or with icons => type is `sprites` then a svg tag instead
     * @param iconClass
     * @private
     */

  }, {
    key: "_iconTag",
    value: function _iconTag(iconClass) {
      var _icon$classList;

      if (this.optionsStore.options.display.icons.type === 'sprites') {
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

        var _icon = document.createElementNS('http://www.w3.org/2000/svg', 'use');

        _icon.setAttribute('xlink:href', iconClass); // Deprecated. Included for backward compatibility


        _icon.setAttribute('href', iconClass);

        svg.appendChild(_icon);
        return svg;
      }

      var icon = document.createElement('i');

      (_icon$classList = icon.classList).add.apply(_icon$classList, _toConsumableArray(iconClass.split(' ')));

      return icon;
    }
    /**
     * Causes the widget to get rebuilt on next show. If the picker is already open
     * then hide and reshow it.
     * @private
     */

  }, {
    key: "_rebuild",
    value: function _rebuild() {
      var wasVisible = this._isVisible;

      this._dispose();

      if (wasVisible) this.show();
    }
  }, {
    key: "refreshCurrentView",
    value: function refreshCurrentView() {
      //if the widget is not showing, just destroy it
      if (!this._isVisible) this._dispose();

      switch (this.optionsStore.currentView) {
        case 'clock':
          this._update('clock');

          break;

        case 'calendar':
          this._update(Unit.date);

          break;

        case 'months':
          this._update(Unit.month);

          break;

        case 'years':
          this._update(Unit.year);

          break;

        case 'decades':
          this._update('decade');

          break;
      }
    }
  }, {
    key: "widget",
    get: function get() {
      return this._widget;
    }
  }, {
    key: "dateContainer",
    get: function get() {
      var _this$widget;

      return (_this$widget = this.widget) === null || _this$widget === void 0 ? void 0 : _this$widget.querySelector("div.".concat(Namespace.css.dateContainer));
    }
  }, {
    key: "timeContainer",
    get: function get() {
      var _this$widget2;

      return (_this$widget2 = this.widget) === null || _this$widget2 === void 0 ? void 0 : _this$widget2.querySelector("div.".concat(Namespace.css.timeContainer));
    }
    /**
     * Returns this visible state of the picker (shown)
     */

  }, {
    key: "isVisible",
    get: function get() {
      return this._isVisible;
    }
  }, {
    key: "_hasTime",
    get: function get() {
      return this.optionsStore.options.display.components.clock && (this.optionsStore.options.display.components.hours || this.optionsStore.options.display.components.minutes || this.optionsStore.options.display.components.seconds);
    }
    /**
     * Returns true if the year, month, or date component is turned on
     */

  }, {
    key: "_hasDate",
    get: function get() {
      return this.optionsStore.options.display.components.calendar && (this.optionsStore.options.display.components.year || this.optionsStore.options.display.components.month || this.optionsStore.options.display.components.date);
    }
  }, {
    key: "_hasDateAndTime",
    get: function get() {
      return this._hasDate && this._hasTime;
    }
  }]);

  return Display;
}();
/**
 * Logic for various click actions
 */


var Actions = /*#__PURE__*/function () {
  function Actions() {
    var _this18 = this;

    _classCallCheck(this, Actions);

    this.optionsStore = serviceLocator.locate(OptionsStore);
    this.dates = serviceLocator.locate(Dates);
    this.validation = serviceLocator.locate(Validation);
    this.display = serviceLocator.locate(Display);
    this._eventEmitters = serviceLocator.locate(EventEmitters);

    this._eventEmitters.action.subscribe(function (result) {
      _this18.do(result.e, result.action);
    });
  }
  /**
   * Performs the selected `action`. See ActionTypes
   * @param e This is normally a click event
   * @param action If not provided, then look for a [data-action]
   */
  //eslint-disable-next-line @typescript-eslint/no-explicit-any


  _createClass(Actions, [{
    key: "do",
    value: function _do(e, action) {
      var _currentTarget$classL, _currentTarget$datase;

      var currentTarget = e === null || e === void 0 ? void 0 : e.currentTarget;
      if (currentTarget === null || currentTarget === void 0 ? void 0 : (_currentTarget$classL = currentTarget.classList) === null || _currentTarget$classL === void 0 ? void 0 : _currentTarget$classL.contains(Namespace.css.disabled)) return;
      action = action || (currentTarget === null || currentTarget === void 0 ? void 0 : (_currentTarget$datase = currentTarget.dataset) === null || _currentTarget$datase === void 0 ? void 0 : _currentTarget$datase.action);
      var lastPicked = (this.dates.lastPicked || this.optionsStore.viewDate).clone;

      switch (action) {
        case ActionTypes$1.next:
        case ActionTypes$1.previous:
          this.handleNextPrevious(action);
          break;

        case ActionTypes$1.changeCalendarView:
          this.display._showMode(1);

          this.display._updateCalendarHeader();

          break;

        case ActionTypes$1.selectMonth:
        case ActionTypes$1.selectYear:
        case ActionTypes$1.selectDecade:
          this.handleSelectCalendarMode(action, currentTarget);
          break;

        case ActionTypes$1.selectDay:
          this.handleSelectDay(currentTarget);
          break;

        case ActionTypes$1.selectHour:
          {
            var hour = +currentTarget.dataset.value;
            if (lastPicked.hours >= 12 && this.optionsStore.isTwelveHour) hour += 12;
            lastPicked.hours = hour;
            this.dates.setValue(lastPicked, this.dates.lastPickedIndex);
            this.hideOrClock(e);
            break;
          }

        case ActionTypes$1.selectMinute:
          {
            lastPicked.minutes = +currentTarget.dataset.value;
            this.dates.setValue(lastPicked, this.dates.lastPickedIndex);
            this.hideOrClock(e);
            break;
          }

        case ActionTypes$1.selectSecond:
          {
            lastPicked.seconds = +currentTarget.dataset.value;
            this.dates.setValue(lastPicked, this.dates.lastPickedIndex);
            this.hideOrClock(e);
            break;
          }

        case ActionTypes$1.incrementHours:
          this.manipulateAndSet(lastPicked, Unit.hours);
          break;

        case ActionTypes$1.incrementMinutes:
          this.manipulateAndSet(lastPicked, Unit.minutes, this.optionsStore.options.stepping);
          break;

        case ActionTypes$1.incrementSeconds:
          this.manipulateAndSet(lastPicked, Unit.seconds);
          break;

        case ActionTypes$1.decrementHours:
          this.manipulateAndSet(lastPicked, Unit.hours, -1);
          break;

        case ActionTypes$1.decrementMinutes:
          this.manipulateAndSet(lastPicked, Unit.minutes, this.optionsStore.options.stepping * -1);
          break;

        case ActionTypes$1.decrementSeconds:
          this.manipulateAndSet(lastPicked, Unit.seconds, -1);
          break;

        case ActionTypes$1.toggleMeridiem:
          this.manipulateAndSet(lastPicked, Unit.hours, this.dates.lastPicked.hours >= 12 ? -12 : 12);
          break;

        case ActionTypes$1.togglePicker:
          this.handleToggle(currentTarget);
          break;

        case ActionTypes$1.showClock:
        case ActionTypes$1.showHours:
        case ActionTypes$1.showMinutes:
        case ActionTypes$1.showSeconds:
          //make sure the clock is actually displaying
          if (!this.optionsStore.options.display.sideBySide && this.optionsStore.currentView !== 'clock') {
            //hide calendar
            Collapse.hideImmediately(this.display.dateContainer); //show clock

            Collapse.showImmediately(this.display.timeContainer);
          }

          this.handleShowClockContainers(action);
          break;

        case ActionTypes$1.clear:
          this.dates.setValue(null);

          this.display._updateCalendarHeader();

          break;

        case ActionTypes$1.close:
          this.display.hide();
          break;

        case ActionTypes$1.today:
          {
            var today = new DateTime().setLocalization(this.optionsStore.options.localization);

            this._eventEmitters.updateViewDate.emit(today); //todo this this really a good idea?


            if (this.validation.isValid(today, Unit.date)) this.dates.setValue(today, this.dates.lastPickedIndex);
            break;
          }
      }
    }
  }, {
    key: "handleShowClockContainers",
    value: function handleShowClockContainers(action) {
      if (!this.display._hasTime) {
        Namespace.errorMessages.throwError('Cannot show clock containers when time is disabled.');
        /* ignore coverage: should never happen */

        return;
      }

      this.optionsStore.currentView = 'clock';
      this.display.widget.querySelectorAll(".".concat(Namespace.css.timeContainer, " > div")).forEach(function (htmlElement) {
        return htmlElement.style.display = 'none';
      });
      var classToUse = '';

      switch (action) {
        case ActionTypes$1.showClock:
          classToUse = Namespace.css.clockContainer;

          this.display._update('clock');

          break;

        case ActionTypes$1.showHours:
          classToUse = Namespace.css.hourContainer;

          this.display._update(Unit.hours);

          break;

        case ActionTypes$1.showMinutes:
          classToUse = Namespace.css.minuteContainer;

          this.display._update(Unit.minutes);

          break;

        case ActionTypes$1.showSeconds:
          classToUse = Namespace.css.secondContainer;

          this.display._update(Unit.seconds);

          break;
      }

      this.display.widget.getElementsByClassName(classToUse)[0].style.display = 'grid';
    }
  }, {
    key: "handleNextPrevious",
    value: function handleNextPrevious(action) {
      var _CalendarModes$this$o = CalendarModes[this.optionsStore.currentCalendarViewMode],
          unit = _CalendarModes$this$o.unit,
          step = _CalendarModes$this$o.step;
      if (action === ActionTypes$1.next) this.optionsStore.viewDate.manipulate(step, unit);else this.optionsStore.viewDate.manipulate(step * -1, unit);

      this._eventEmitters.viewUpdate.emit();

      this.display._showMode();
    }
    /**
     * After setting the value it will either show the clock or hide the widget.
     * @param e
     */

  }, {
    key: "hideOrClock",
    value: function hideOrClock(e) {
      if (!this.optionsStore.isTwelveHour && !this.optionsStore.options.display.components.minutes && !this.optionsStore.options.display.keepOpen && !this.optionsStore.options.display.inline) {
        this.display.hide();
      } else {
        this.do(e, ActionTypes$1.showClock);
      }
    }
    /**
     * Common function to manipulate {@link lastPicked} by `unit`.
     * @param lastPicked
     * @param unit
     * @param value Value to change by
     */

  }, {
    key: "manipulateAndSet",
    value: function manipulateAndSet(lastPicked, unit) {
      var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var newDate = lastPicked.manipulate(value, unit);

      if (this.validation.isValid(newDate, unit)) {
        this.dates.setValue(newDate, this.dates.lastPickedIndex);
      }
    }
  }, {
    key: "handleSelectCalendarMode",
    value: function handleSelectCalendarMode(action, currentTarget) {
      var value = +currentTarget.dataset.value;

      switch (action) {
        case ActionTypes$1.selectMonth:
          this.optionsStore.viewDate.month = value;
          break;

        case ActionTypes$1.selectYear:
        case ActionTypes$1.selectDecade:
          this.optionsStore.viewDate.year = value;
          break;
      }

      if (this.optionsStore.currentCalendarViewMode === this.optionsStore.minimumCalendarViewMode) {
        this.dates.setValue(this.optionsStore.viewDate, this.dates.lastPickedIndex);

        if (!this.optionsStore.options.display.inline) {
          this.display.hide();
        }
      } else {
        this.display._showMode(-1);
      }
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(currentTarget) {
      if (currentTarget.getAttribute('title') === this.optionsStore.options.localization.selectDate) {
        currentTarget.setAttribute('title', this.optionsStore.options.localization.selectTime);
        currentTarget.innerHTML = this.display._iconTag(this.optionsStore.options.display.icons.time).outerHTML;

        this.display._updateCalendarHeader();

        this.optionsStore.refreshCurrentView();
      } else {
        currentTarget.setAttribute('title', this.optionsStore.options.localization.selectDate);
        currentTarget.innerHTML = this.display._iconTag(this.optionsStore.options.display.icons.date).outerHTML;

        if (this.display._hasTime) {
          this.handleShowClockContainers(ActionTypes$1.showClock);

          this.display._update('clock');
        }
      }

      this.display.widget.querySelectorAll(".".concat(Namespace.css.dateContainer, ", .").concat(Namespace.css.timeContainer)).forEach(function (htmlElement) {
        return Collapse.toggle(htmlElement);
      });

      this._eventEmitters.viewUpdate.emit();
    }
  }, {
    key: "handleSelectDay",
    value: function handleSelectDay(currentTarget) {
      var day = this.optionsStore.viewDate.clone;

      if (currentTarget.classList.contains(Namespace.css.old)) {
        day.manipulate(-1, Unit.month);
      }

      if (currentTarget.classList.contains(Namespace.css.new)) {
        day.manipulate(1, Unit.month);
      }

      day.date = +currentTarget.dataset.day;
      if (this.optionsStore.options.dateRange) this.handleDateRange(day);else if (this.optionsStore.options.multipleDates) {
        this.handleMultiDate(day);
      } else {
        this.dates.setValue(day, this.dates.lastPickedIndex);
      }

      if (!this.display._hasTime && !this.optionsStore.options.display.keepOpen && !this.optionsStore.options.display.inline && !this.optionsStore.options.multipleDates && !this.optionsStore.options.dateRange) {
        this.display.hide();
      }
    }
  }, {
    key: "handleMultiDate",
    value: function handleMultiDate(day) {
      var index = this.dates.pickedIndex(day, Unit.date);
      console.log(index);

      if (index !== -1) {
        this.dates.setValue(null, index); //deselect multi-date
      } else {
        index = this.dates.lastPickedIndex + 1;
        if (this.dates.picked.length === 0) index = 0;
        this.dates.setValue(day, index);
      }
    }
  }, {
    key: "handleDateRange",
    value: function handleDateRange(day) {
      switch (this.dates.picked.length) {
        case 2:
          {
            this.dates.clear();
            break;
          }

        case 1:
          {
            var other = this.dates.picked[0];

            if (day.getTime() === other.getTime()) {
              this.dates.clear();
              break;
            }

            if (day.isBefore(other)) {
              this.dates.setValue(day, 0);
              this.dates.setValue(other, 1);
              return;
            } else {
              this.dates.setValue(day, 1);
              return;
            }
          }
      }

      this.dates.setValue(day, 0);
    }
  }]);

  return Actions;
}();
/**
 * A robust and powerful date/time picker component.
 */


var TempusDominus = /*#__PURE__*/function () {
  function TempusDominus(element) {
    var _this19 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, TempusDominus);

    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    this._subscribers = {};
    this._isDisabled = false;
    /**
     * Event for when the input field changes. This is a class level method so there's
     * something for the remove listener function.
     * @private
     */
    //eslint-disable-next-line @typescript-eslint/no-explicit-any

    this._inputChangeEvent = function (event) {
      var internallyTriggered = event === null || event === void 0 ? void 0 : event.detail;
      if (internallyTriggered) return;

      var setViewDate = function setViewDate() {
        if (_this19.dates.lastPicked) _this19.optionsStore.viewDate = _this19.dates.lastPicked.clone;
      };

      var value = _this19.optionsStore.input.value;

      if (_this19.optionsStore.options.multipleDates || _this19.optionsStore.options.dateRange) {
        try {
          var valueSplit = value.split(_this19.optionsStore.options.multipleDatesSeparator);

          for (var i = 0; i < valueSplit.length; i++) {
            _this19.dates.setFromInput(valueSplit[i], i);
          }

          setViewDate();
        } catch (_unused) {
          console.warn('TD: Something went wrong trying to set the multipleDates values from the input field.');
        }
      } else {
        _this19.dates.setFromInput(value, 0);

        setViewDate();
      }
    };
    /**
     * Event for when the toggle is clicked. This is a class level method so there's
     * something for the remove listener function.
     * @private
     */


    this._toggleClickEvent = function () {
      var _this19$optionsStore$, _this19$optionsStore$2, _this19$_toggle;

      if (((_this19$optionsStore$ = _this19.optionsStore.element) === null || _this19$optionsStore$ === void 0 ? void 0 : _this19$optionsStore$.disabled) || ((_this19$optionsStore$2 = _this19.optionsStore.input) === null || _this19$optionsStore$2 === void 0 ? void 0 : _this19$optionsStore$2.disabled) || //if we just have the input and allow input toggle is enabled, then don't cause a toggle
      _this19._toggle.nodeName === 'INPUT' && ((_this19$_toggle = _this19._toggle) === null || _this19$_toggle === void 0 ? void 0 : _this19$_toggle.type) === 'text' && _this19.optionsStore.options.allowInputToggle) return;

      _this19.toggle();
    };
    /**
     * Event for when the toggle is clicked. This is a class level method so there's
     * something for the remove listener function.
     * @private
     */


    this._openClickEvent = function () {
      var _this19$optionsStore$3, _this19$optionsStore$4;

      if (((_this19$optionsStore$3 = _this19.optionsStore.element) === null || _this19$optionsStore$3 === void 0 ? void 0 : _this19$optionsStore$3.disabled) || ((_this19$optionsStore$4 = _this19.optionsStore.input) === null || _this19$optionsStore$4 === void 0 ? void 0 : _this19$optionsStore$4.disabled)) return;
      if (!_this19.display.isVisible) _this19.show();
    };

    setupServiceLocator();
    this._eventEmitters = serviceLocator.locate(EventEmitters);
    this.optionsStore = serviceLocator.locate(OptionsStore);
    this.display = serviceLocator.locate(Display);
    this.dates = serviceLocator.locate(Dates);
    this.actions = serviceLocator.locate(Actions);

    if (!element) {
      Namespace.errorMessages.mustProvideElement();
    }

    this.optionsStore.element = element;

    this._initializeOptions(options, DefaultOptions, true);

    this.optionsStore.viewDate.setLocalization(this.optionsStore.options.localization);
    this.optionsStore.unset = true;

    this._initializeInput();

    this._initializeToggle();

    if (this.optionsStore.options.display.inline) this.display.show();

    this._eventEmitters.triggerEvent.subscribe(function (e) {
      _this19._triggerEvent(e);
    });

    this._eventEmitters.viewUpdate.subscribe(function () {
      _this19._viewUpdate();
    });

    this._eventEmitters.updateViewDate.subscribe(function (dateTime) {
      _this19.viewDate = dateTime;
    });
  }

  _createClass(TempusDominus, [{
    key: "updateOptions",
    // noinspection JSUnusedGlobalSymbols

    /**
     * Update the picker options. If `reset` is provide `options` will be merged with DefaultOptions instead.
     * @param options
     * @param reset
     * @public
     */
    value: function updateOptions(options) {
      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (reset) this._initializeOptions(options, DefaultOptions);else this._initializeOptions(options, this.optionsStore.options);
      this.optionsStore.viewDate.setLocalization(this.optionsStore.options.localization);
      this.display.refreshCurrentView();
    } // noinspection JSUnusedGlobalSymbols

    /**
     * Toggles the picker open or closed. If the picker is disabled, nothing will happen.
     * @public
     */

  }, {
    key: "toggle",
    value: function toggle() {
      if (this._isDisabled) return;
      this.display.toggle();
    } // noinspection JSUnusedGlobalSymbols

    /**
     * Shows the picker unless the picker is disabled.
     * @public
     */

  }, {
    key: "show",
    value: function show() {
      if (this._isDisabled) return;
      this.display.show();
    } // noinspection JSUnusedGlobalSymbols

    /**
     * Hides the picker unless the picker is disabled.
     * @public
     */

  }, {
    key: "hide",
    value: function hide() {
      this.display.hide();
    } // noinspection JSUnusedGlobalSymbols

    /**
     * Disables the picker and the target input field.
     * @public
     */

  }, {
    key: "disable",
    value: function disable() {
      var _this$optionsStore$in;

      this._isDisabled = true; // todo this might be undesired. If a dev disables the input field to
      // only allow using the picker, this will break that.

      (_this$optionsStore$in = this.optionsStore.input) === null || _this$optionsStore$in === void 0 ? void 0 : _this$optionsStore$in.setAttribute('disabled', 'disabled');
      this.display.hide();
    } // noinspection JSUnusedGlobalSymbols

    /**
     * Enables the picker and the target input field.
     * @public
     */

  }, {
    key: "enable",
    value: function enable() {
      var _this$optionsStore$in2;

      this._isDisabled = false;
      (_this$optionsStore$in2 = this.optionsStore.input) === null || _this$optionsStore$in2 === void 0 ? void 0 : _this$optionsStore$in2.removeAttribute('disabled');
    } // noinspection JSUnusedGlobalSymbols

    /**
     * Clears all the selected dates
     * @public
     */

  }, {
    key: "clear",
    value: function clear() {
      this.optionsStore.input.value = '';
      this.dates.clear();
    } // noinspection JSUnusedGlobalSymbols

    /**
     * Allows for a direct subscription to picker events, without having to use addEventListener on the element.
     * @param eventTypes See Namespace.Events
     * @param callbacks Function to call when event is triggered
     * @public
     */

  }, {
    key: "subscribe",
    value: function subscribe(eventTypes, callbacks //eslint-disable-line @typescript-eslint/no-explicit-any
    ) {
      if (typeof eventTypes === 'string') {
        eventTypes = [eventTypes];
      }

      var callBackArray; //eslint-disable-line @typescript-eslint/no-explicit-any

      if (!Array.isArray(callbacks)) {
        callBackArray = [callbacks];
      } else {
        callBackArray = callbacks;
      }

      if (eventTypes.length !== callBackArray.length) {
        Namespace.errorMessages.subscribeMismatch();
      }

      var returnArray = [];

      for (var i = 0; i < eventTypes.length; i++) {
        var eventType = eventTypes[i];

        if (!Array.isArray(this._subscribers[eventType])) {
          this._subscribers[eventType] = [];
        }

        this._subscribers[eventType].push(callBackArray[i]);

        returnArray.push({
          unsubscribe: this._unsubscribe.bind(this, eventType, this._subscribers[eventType].length - 1)
        });

        if (eventTypes.length === 1) {
          return returnArray[0];
        }
      }

      return returnArray;
    } // noinspection JSUnusedGlobalSymbols

    /**
     * Hides the picker and removes event listeners
     */

  }, {
    key: "dispose",
    value: function dispose() {
      var _this$optionsStore$in3, _this$_toggle;

      this.display.hide(); // this will clear the document click event listener

      this.display._dispose();

      this._eventEmitters.destroy();

      (_this$optionsStore$in3 = this.optionsStore.input) === null || _this$optionsStore$in3 === void 0 ? void 0 : _this$optionsStore$in3.removeEventListener('change', this._inputChangeEvent);

      if (this.optionsStore.options.allowInputToggle) {
        var _this$optionsStore$in4, _this$optionsStore$in5;

        (_this$optionsStore$in4 = this.optionsStore.input) === null || _this$optionsStore$in4 === void 0 ? void 0 : _this$optionsStore$in4.removeEventListener('click', this._openClickEvent);
        (_this$optionsStore$in5 = this.optionsStore.input) === null || _this$optionsStore$in5 === void 0 ? void 0 : _this$optionsStore$in5.removeEventListener('focus', this._openClickEvent);
      }

      (_this$_toggle = this._toggle) === null || _this$_toggle === void 0 ? void 0 : _this$_toggle.removeEventListener('click', this._toggleClickEvent);
      this._subscribers = {};
    }
    /**
     * Updates the options to use the provided language.
     * THe language file must be loaded first.
     * @param language
     */

  }, {
    key: "locale",
    value: function locale(language) {
      var asked = loadedLocales[language];
      if (!asked) return;
      this.updateOptions({
        localization: asked
      });
    }
    /**
     * Triggers an event like ChangeEvent when the picker has updated the value
     * of a selected date.
     * @param event Accepts a BaseEvent object.
     * @private
     */

  }, {
    key: "_triggerEvent",
    value: function _triggerEvent(event) {
      event.viewMode = this.optionsStore.currentView;
      var isChangeEvent = event.type === Namespace.events.change;

      if (isChangeEvent) {
        var _this$optionsStore$in6;

        var date = event.date,
            oldDate = event.oldDate,
            isClear = event.isClear;

        if (date && oldDate && date.isSame(oldDate) || !isClear && !date && !oldDate) {
          return;
        }

        this._handleAfterChangeEvent(event);

        (_this$optionsStore$in6 = this.optionsStore.input) === null || _this$optionsStore$in6 === void 0 ? void 0 : _this$optionsStore$in6.dispatchEvent( //eslint-disable-next-line @typescript-eslint/no-explicit-any
        new CustomEvent('change', {
          detail: event
        }));
      }

      this.optionsStore.element.dispatchEvent( //eslint-disable-next-line @typescript-eslint/no-explicit-any
      new CustomEvent(event.type, {
        detail: event
      })); //eslint-disable-next-line @typescript-eslint/no-explicit-any

      if (window.jQuery) {
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        var $ = window.jQuery;

        if (isChangeEvent && this.optionsStore.input) {
          $(this.optionsStore.input).trigger(event);
        } else {
          $(this.optionsStore.element).trigger(event);
        }
      }

      this._publish(event);
    }
  }, {
    key: "_publish",
    value: function _publish(event) {
      // return if event is not subscribed
      if (!Array.isArray(this._subscribers[event.type])) {
        return;
      } // Trigger callback for each subscriber


      this._subscribers[event.type].forEach(function (callback) {
        callback(event);
      });
    }
    /**
     * Fires a ViewUpdate event when, for example, the month view is changed.
     * @private
     */

  }, {
    key: "_viewUpdate",
    value: function _viewUpdate() {
      this._triggerEvent({
        type: Namespace.events.update,
        viewDate: this.optionsStore.viewDate.clone
      });
    }
  }, {
    key: "_unsubscribe",
    value: function _unsubscribe(eventName, index) {
      this._subscribers[eventName].splice(index, 1);
    }
    /**
     * Merges two Option objects together and validates options type
     * @param config new Options
     * @param mergeTo Options to merge into
     * @param includeDataset When true, the elements data-td attributes will be included in the
     * @private
     */

  }, {
    key: "_initializeOptions",
    value: function _initializeOptions(config, mergeTo) {
      var _this$display;

      var includeDataset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var newConfig = OptionConverter.deepCopy(config);
      newConfig = OptionConverter._mergeOptions(newConfig, mergeTo);
      if (includeDataset) newConfig = OptionConverter._dataToOptions(this.optionsStore.element, newConfig);

      OptionConverter._validateConflicts(newConfig);

      newConfig.viewDate = newConfig.viewDate.setLocalization(newConfig.localization);

      if (!this.optionsStore.viewDate.isSame(newConfig.viewDate)) {
        this.optionsStore.viewDate = newConfig.viewDate;
      }
      /**
       * Sets the minimum view allowed by the picker. For example the case of only
       * allowing year and month to be selected but not date.
       */


      if (newConfig.display.components.year) {
        this.optionsStore.minimumCalendarViewMode = 2;
      }

      if (newConfig.display.components.month) {
        this.optionsStore.minimumCalendarViewMode = 1;
      }

      if (newConfig.display.components.date) {
        this.optionsStore.minimumCalendarViewMode = 0;
      }

      this.optionsStore.currentCalendarViewMode = Math.max(this.optionsStore.minimumCalendarViewMode, this.optionsStore.currentCalendarViewMode); // Update view mode if needed

      if (CalendarModes[this.optionsStore.currentCalendarViewMode].name !== newConfig.display.viewMode) {
        this.optionsStore.currentCalendarViewMode = Math.max(CalendarModes.findIndex(function (x) {
          return x.name === newConfig.display.viewMode;
        }), this.optionsStore.minimumCalendarViewMode);
      }

      if ((_this$display = this.display) === null || _this$display === void 0 ? void 0 : _this$display.isVisible) {
        this.display._update('all');
      }

      if (newConfig.display.components.useTwentyfourHour && newConfig.localization.hourCycle === undefined) newConfig.localization.hourCycle = 'h24';else if (newConfig.localization.hourCycle === undefined) {
        newConfig.localization.hourCycle = guessHourCycle(newConfig.localization.locale);
      }
      this.optionsStore.options = newConfig;
      if (newConfig.restrictions.maxDate && this.viewDate.isAfter(newConfig.restrictions.maxDate)) this.viewDate = newConfig.restrictions.maxDate.clone;
      if (newConfig.restrictions.minDate && this.viewDate.isBefore(newConfig.restrictions.minDate)) this.viewDate = newConfig.restrictions.minDate.clone;
    }
    /**
     * Checks if an input field is being used, attempts to locate one and sets an
     * event listener if found.
     * @private
     */

  }, {
    key: "_initializeInput",
    value: function _initializeInput() {
      if (this.optionsStore.element.tagName == 'INPUT') {
        this.optionsStore.input = this.optionsStore.element;
      } else {
        var query = this.optionsStore.element.dataset.tdTargetInput;

        if (query == undefined || query == 'nearest') {
          this.optionsStore.input = this.optionsStore.element.querySelector('input');
        } else {
          this.optionsStore.input = this.optionsStore.element.querySelector(query);
        }
      }

      if (!this.optionsStore.input) return;
      if (!this.optionsStore.input.value && this.optionsStore.options.defaultDate) this.optionsStore.input.value = this.dates.formatInput(this.optionsStore.options.defaultDate);
      this.optionsStore.input.addEventListener('change', this._inputChangeEvent);

      if (this.optionsStore.options.allowInputToggle) {
        this.optionsStore.input.addEventListener('click', this._openClickEvent);
        this.optionsStore.input.addEventListener('focus', this._openClickEvent);
      }

      if (this.optionsStore.input.value) {
        this._inputChangeEvent();
      }
    }
    /**
     * Attempts to locate a toggle for the picker and sets an event listener
     * @private
     */

  }, {
    key: "_initializeToggle",
    value: function _initializeToggle() {
      if (this.optionsStore.options.display.inline) return;
      var query = this.optionsStore.element.dataset.tdTargetToggle;

      if (query == 'nearest') {
        query = '[data-td-toggle="datetimepicker"]';
      }

      this._toggle = query == undefined ? this.optionsStore.element : this.optionsStore.element.querySelector(query);

      this._toggle.addEventListener('click', this._toggleClickEvent);
    }
    /**
     * If the option is enabled this will render the clock view after a date pick.
     * @param e change event
     * @private
     */

  }, {
    key: "_handleAfterChangeEvent",
    value: function _handleAfterChangeEvent(e) {
      var _this$display$widget,
          _e$date,
          _this20 = this;

      if ( // options is disabled
      !this.optionsStore.options.promptTimeOnDateChange || this.optionsStore.options.multipleDates || this.optionsStore.options.display.inline || this.optionsStore.options.display.sideBySide || // time is disabled
      !this.display._hasTime || ( // clock component is already showing
      (_this$display$widget = this.display.widget) === null || _this$display$widget === void 0 ? void 0 : _this$display$widget.getElementsByClassName(Namespace.css.show)[0].classList.contains(Namespace.css.timeContainer))) return; // First time ever. If useCurrent option is set to true (default), do nothing
      // because the first date is selected automatically.
      // or date didn't change (time did) or date changed because time did.

      if (!e.oldDate && this.optionsStore.options.useCurrent || e.oldDate && ((_e$date = e.date) === null || _e$date === void 0 ? void 0 : _e$date.isSame(e.oldDate))) {
        return;
      }

      clearTimeout(this._currentPromptTimeTimeout);
      this._currentPromptTimeTimeout = setTimeout(function () {
        if (_this20.display.widget) {
          _this20._eventEmitters.action.emit({
            e: {
              currentTarget: _this20.display.widget.querySelector('[data-action="togglePicker"]')
            },
            action: ActionTypes$1.togglePicker
          });
        }
      }, this.optionsStore.options.promptTimeOnDateChangeTransitionDelay);
    }
  }, {
    key: "viewDate",
    get: function get() {
      return this.optionsStore.viewDate;
    },
    set: function set(value) {
      this.optionsStore.viewDate = value;
      this.optionsStore.viewDate.setLocalization(this.optionsStore.options.localization);

      this.display._update(this.optionsStore.currentView === 'clock' ? 'clock' : 'calendar');
    }
  }]);

  return TempusDominus;
}();
/**
 * Whenever a locale is loaded via a plugin then store it here based on the
 * locale name. E.g. loadedLocales['ru']
 */


var loadedLocales = {}; // noinspection JSUnusedGlobalSymbols

/**
 * Called from a locale plugin.
 * @param l locale object for localization options
 */

var loadLocale = function loadLocale(l) {
  if (loadedLocales[l.name]) return;
  loadedLocales[l.name] = l.localization;
};
/**
 * A sets the global localization options to the provided locale name.
 * `loadLocale` MUST be called first.
 * @param l
 */


var locale = function locale(l) {
  var asked = loadedLocales[l];
  if (!asked) return;
  DefaultOptions.localization = asked;
}; // noinspection JSUnusedGlobalSymbols

/**
 * Called from a plugin to extend or override picker defaults.
 * @param plugin
 * @param option
 */


var extend = function extend(plugin) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  if (!plugin) return tempusDominus;

  if (!plugin.installed) {
    // install plugin only once
    plugin(option, {
      TempusDominus: TempusDominus,
      Dates: Dates,
      Display: Display,
      DateTime: DateTime,
      Namespace: Namespace
    }, tempusDominus);
    plugin.installed = true;
  }

  return tempusDominus;
};

var version = '6.9.4';
var tempusDominus = {
  TempusDominus: TempusDominus,
  extend: extend,
  loadLocale: loadLocale,
  locale: locale,
  Namespace: Namespace,
  DefaultOptions: DefaultOptions,
  DateTime: DateTime,
  Unit: Unit,
  version: version,
  DefaultEnLocalization: DefaultEnLocalization
};
export { DateTime, DefaultEnLocalization, DefaultOptions, Namespace, TempusDominus, Unit, extend, loadLocale, locale, version };